import { documentNumberTranslations } from './document-number-i18n';
import { duplicationTranslations } from './duplication-i18n';
import { partnerMapTranslations } from './partner-map-i18n';
import { actionNeedTranslations } from './action-needs-i18n';
import { listViewTranslations } from './list-view-i18n';
import { pdfFieldCheckTranslations } from './pdf-field-check-i18n';
import { batchSelectionTranslations } from './batch-selection-i18n';
import { documentProgressTranslations } from './document-progress-i18n';
import { stockAdjustmentTranslations } from './stock-adjustment-i18n';
import { documentLockTranslations } from './document-lock-i18n';
import { portalRecoveryTranslations } from './portal-recovery-i18n';

import { priceGroupTranslations } from './price-group-i18n';
import { shippingTranslations } from '@erp/shared';
import { headerTranslations } from './header-i18n';
import { documentEntryTranslations } from './document-entry-i18n';
import { documentWorkspaceTranslations } from './document-workspace-i18n';
import { subdivisionTranslations } from './subdivision-i18n';
import { contactBriefingTranslations } from './contact-briefing-i18n';
import { internationalTranslations } from './international-i18n';
import { deliveryPlanningTranslations } from '@erp/shared';
import { introductionTranslations } from './introduction-i18n';
import { adminDe } from './admin-de';
import { analyticsDe } from './analytics-de';
import { dmsDe } from './dms-de';
import { partnersDe } from './partners-de';
import { pdfDesignerDe } from './pdf-designer-de';
import { procurementDe } from './procurement-de';
import { questionnairesDe } from './questionnaires-de';
import { settingsHubDe } from './settings-hub-de';
import { telephonyDe } from './telephony-de';
import { whatsAppDe } from './whatsapp-de';
import { helpDe } from './help-de';
import { feedbackDe } from './feedback-de';
import { productSpecificationsDe } from './product-specifications-de';
import { plmDe } from './plm-de';
import { manufacturingDe } from './manufacturing-de';
import { traceabilityDe } from './traceability-de';
import { mrpDe } from './mrp-de';
import { labelsDe } from './labels-de';
import { changeControlDe } from './change-control-de';
import { productDevelopmentDashboardDe } from './product-development-dashboard-de';
import { searchDe } from './search-i18n';
import { vatValidationDe } from './vat-validation-i18n';
import { navigationDe } from './navigation-i18n';
import { dunningDe } from './dunning-i18n';
import { portalDe } from './portal-i18n';
import { productNewsDe } from './product-news-i18n';
import { newsletterDe } from './newsletter-i18n';
import { setupDe } from './setup-i18n';
import { importCenterDe } from './import-center-i18n';
import { bankingDe } from './banking-i18n';
import { translationGlossaryDe } from './translation-glossary-i18n';
import { salesAssistantDe } from './sales-assistant-i18n';
import { customerHeaderDe } from './customer-header-i18n';
import { dashboardDe } from './dashboard-i18n';
import { featureAdminDe } from './feature-admin-i18n';

export const de = {
  translation: {
    documentNumber: documentNumberTranslations.de,
    duplication: duplicationTranslations.de,
    partnerMap: partnerMapTranslations.de,
    actionNeeds: actionNeedTranslations.de,
    listViews: listViewTranslations.de,
    pdfFieldCheck: pdfFieldCheckTranslations.de,
    stockAdjustment: stockAdjustmentTranslations.de,
    batchSelection: batchSelectionTranslations.de,
    documentProgress: documentProgressTranslations.de,
    documentLock: documentLockTranslations.de,
    portalRecovery: portalRecoveryTranslations.de,
    shipping: shippingTranslations.de,
    priceGroups: priceGroupTranslations.de,
    header: headerTranslations.de,
    documentEntry: documentEntryTranslations.de,
    documentWorkspace: documentWorkspaceTranslations.de,
    ...contactBriefingTranslations.de,
    international: internationalTranslations.de,
    subdivision: subdivisionTranslations.de,
    deliveryPlanning: deliveryPlanningTranslations.de,
    introduction: introductionTranslations.de,
    admin: { ...adminDe, dataHub: importCenterDe, features: featureAdminDe },
    analytics: analyticsDe,
    dms: dmsDe,
    portal: portalDe,
    productNews: productNewsDe,
    newsletter: newsletterDe,
    setup: setupDe,
    partners: partnersDe,
    pdfDesigner: pdfDesignerDe,
    procurement: procurementDe,
    questionnaires: questionnairesDe,
    settingsHub: settingsHubDe,
    telephony: telephonyDe,
    whatsapp: whatsAppDe,
    help: helpDe,
    feedback: feedbackDe,
    productSpecifications: productSpecificationsDe,
    plm: plmDe,
    manufacturing: manufacturingDe,
    traceability: traceabilityDe,
    mrp: mrpDe,
    labels: labelsDe,
    changeControl: changeControlDe,
    productDevelopmentDashboard: productDevelopmentDashboardDe,
    search: searchDe,
    vatValidation: vatValidationDe,
    dunning: dunningDe,
    banking: bankingDe,
    translationGlossary: translationGlossaryDe,
    paymentTerms: {
      netDays_one: '{{count}} Tag netto',
      netDays_other: '{{count}} Tage netto',
      discountPreview: '{{due}}, {{percent}} % Skonto innerhalb von {{days}} Tagen',
      customLegacy: 'Individuelle Altkondition',
      search: 'Zahlungsbedingungen durchsuchen …',
      noResults: 'Keine passende Zahlungsbedingung gefunden.',
      loadError: 'Die Zahlungsbedingungen konnten nicht geladen werden.',
      warningCustom: 'Diese Altkondition ist keiner konfigurierten Regel zugeordnet.',
      warningInconsistent:
        'Die Altdaten sind widersprüchlich. Bitte eine gültige Zahlungsbedingung auswählen.',
      advanced: 'Individuelle Zahlungswerte',
      customAgreement: 'Individuelle Vereinbarung',
      selectionHint:
        'Zahlungsziel und Skonto werden automatisch aus der ausgewählten Zahlungsbedingung übernommen.',
      customHint:
        'Diese individuellen Werte gelten anstelle einer Katalogkondition. Eine Auswahl oben ersetzt sie.',
      customize: 'Individuell vereinbaren',
      inconsistentValues:
        'Skontofrist, Skonto und Zahlungsziel passen nicht zusammen. Bitte Werte prüfen oder eine Zahlungsbedingung auswählen.',
      savedValues: 'Gespeicherte Kondition · {{due}} · {{percent}} % Skonto in {{days}} Tagen',
    },
    addressResolution: {
      automatic: 'Automatisch ermittelt',
      adoptRegion: 'Ermittelte Region {{region}} übernehmen',
      importPlan: 'Regionszuordnung im bestätigten Testlauf (manuelle Werte bleiben erhalten)',
      status: {
        RESOLVED: 'Region eindeutig ermittelt.',
        INCOMPLETE: 'Bitte eine vollständige fünfstellige Postleitzahl eingeben.',
        UNSUPPORTED: 'Für dieses Land ist keine automatische Regionszuordnung vorgesehen.',
        NO_MATCH:
          'Keine passende Gemeinde gefunden. Bitte Adresse prüfen oder Region manuell eingeben.',
        CONFLICT:
          'Ort und Postleitzahl passen nicht zusammen. Bitte korrigieren oder einen Ort auswählen.',
        AMBIGUOUS:
          'Die Treffer liegen in verschiedenen Regionen. Bitte den passenden Ort auswählen.',
        MISSING_REGION:
          'Die Verwaltungsdaten enthalten keine vollständige Region. Bitte manuell eingeben.',
        UNAVAILABLE:
          'Die Regionssuche ist derzeit nicht verfügbar. Manuelles Speichern bleibt möglich.',
      },
      backfill: {
        title: 'Leere Regionen französischer Bestandsadressen ergänzen',
        hint: 'Vorschau in Gruppen von höchstens 50 Adressen. Wählen und bestätigen Sie eindeutige Ergänzungen. Geänderte Datensätze und gefüllte Regionen werden übersprungen. Die Vorschau gilt 30 Minuten.',
        partners: 'Hauptadressen prüfen',
        addresses: 'Weitere Adressen prüfen',
        next: 'Nächste Gruppe prüfen',
        empty: 'Keine weiteren französischen Adressen mit leerer Region gefunden.',
        select: '{{label}} zur Ergänzung auswählen',
        apply: '{{count}} ausgewählte Ergänzungen bestätigen',
        result: '{{updated}} ergänzt, {{skipped}} inzwischen geändert oder bereits ergänzt.',
        error:
          'Die Verarbeitung ist fehlgeschlagen. Bitte eine neue Vorschau erstellen und erneut prüfen.',
      },
      loading: 'Ort und Region werden gesucht …',
      errorFallback: 'Die Ortssuche ist gerade nicht erreichbar. Bitte manuell eingeben.',
      noResults: 'Keine Ortszuordnung gefunden. Bitte manuell eingeben.',
      useSuggestion: '{{value}} übernehmen',
      choose: 'Ort auswählen',
      chooseCount: '{{count}} Orte gefunden – bitte auswählen',
      source: 'Quelle: {{source}}',
      help: 'Hilfe zur Ortssuche',
    },
    salesAssistant: salesAssistantDe,
    customerHeader: customerHeaderDe,
    app: {
      name: 'ERP',
      tagline: 'Modulares Web-ERP',
    },
    nav: {
      ...navigationDe,
      label: 'Hauptnavigation',
      openMenu: 'Menü öffnen',
      expandGroup: '{{name}} aufklappen',
      collapseGroup: '{{name}} zuklappen',
      dashboard: 'Dashboard',
      partners: 'Geschäftspartner',
      partnerCustomers: 'Kunden',
      partnerProspects: 'Interessenten / Leads',
      partnerSuppliers: 'Lieferanten',
      partnerAll: 'Alle Kontakte',
      products: 'Artikel',
      productDevelopment: 'Produktentwicklung',
      productDevelopmentOverview: 'Übersicht',
      recipes: 'Rezepturen und BOMs',
      batchScaling: 'Batch-Skalierung',
      declarations: 'Deklarationen',
      declarationCatalog: 'Deklarationsstammdaten',
      analysisProfiles: 'Analyseprofile',
      analysisParameters: 'Analyseparameter',
      labels: 'Etiketten',
      changeControl: 'Änderungsmanagement',
      documents: 'Belege',
      dms: 'Dokumentenablage',
      procurement: 'Einkauf',
      manufacturing: 'Produktion',
      productionOrders: 'Produktionsaufträge',
      traceability: 'Chargenrückverfolgung',
      mrp: 'Materialbedarfsplanung',
      purchaseOrders: 'Bestellungen',
      goodsReceipts: 'Wareneingänge',
      vendorInvoices: 'Eingangsrechnungen',
      analytics: 'Auswertungen',
      analyticsOverview: 'Allgemeine Auswertungen',
      employeePerformance: 'Mitarbeiterperformance',
      datev: 'DATEV-Export',
      intrastat: 'Intrastat',
      settings: 'Einstellungen',
      profile: 'Mein Profil',
      security: 'Sicherheit',
      notifications: 'Benachrichtigungen',
      company: 'Firmendaten',
      pdfDesigner: 'PDF-Vorlagen',
      users: 'Benutzer',
      roles: 'Rollen & Rechte',
      securityLog: 'Sicherheitsprotokoll',
      admin: 'Administration',
      whatsapp: 'WhatsApp',
      whatsappConfig: 'WhatsApp-Konfiguration',
      field: 'Außendienst',
      questionnaireTemplates: 'Fragebögen',
      questionnaireResults: 'Fragebogen-Ergebnisse',
    },
    console: {
      label: 'Verwaltung',
      breadcrumb: 'Navigationspfad',
      openMenu: 'Verwaltungsmenü öffnen',
      backToApp: 'Zurück zur Hauptansicht',
      groups: {
        overview: 'System & Übersicht',
        access: 'Zugriff & Sicherheit',
        configuration: 'Konfiguration',
        communication: 'Kommunikation',
      },
      items: {
        accounting: 'DATEV-Kontenrahmen',
        questionnaireTemplates: 'Fragebogen-Vorlagen',
        questionnaireResults: 'Fragebogen-Ergebnisse',
        questionnaireSettings: 'Fragebogen-Einstellungen',
      },
    },
    theme: {
      label: 'Darstellung',
      light: 'Hell',
      dark: 'Dunkel',
      system: 'System',
    },
    language: {
      label: 'Sprache',
      search: 'Sprache suchen',
      noResults: 'Keine Sprache gefunden.',
      saveError: 'Die Sprache konnte nicht gespeichert werden.',
      tr: 'Türkisch',
      fr: 'Französisch',
      es: 'Spanisch',
      de: 'Deutsch',
      en: 'Englisch',
    },
    dashboard: {
      title: 'Dashboard',
      ...dashboardDe,
    },
    errorPage: {
      title: 'Unerwarteter Fehler',
      description: 'Die Ansicht konnte nicht geladen werden.',
      reload: 'Seite neu laden',
    },
    systemStatus: {
      title: 'Systemstatus',
      description: 'Live-Abfrage der API-Bereitschaft.',
      loading: 'Status wird geladen …',
      error: 'Der Systemstatus konnte nicht geladen werden.',
      retry: 'Erneut versuchen',
      api: 'API',
      database: 'Datenbank',
      version: 'Version',
      uptime: 'Laufzeit',
      state: {
        ok: 'Betriebsbereit',
        degraded: 'Eingeschränkt',
        up: 'Verbunden',
        down: 'Nicht verbunden',
      },
      uptimeValue: '{{minutes}} min',
    },
    common: {
      loading: 'Wird geladen …',
      create: 'Anlegen',
      saving: 'Wird gespeichert…',
      save: 'Speichern',
      confirm: 'Bestätigen',
      select: 'Bitte wählen',
      error: 'Ein unerwarteter Fehler ist aufgetreten.',
      cancel: 'Abbrechen',
      back: 'Zurück',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      close: 'Schließen',
      retry: 'Erneut versuchen',
      previous: 'Zurück',
      next: 'Weiter',
      none: 'Ohne',
      pleaseSelect: 'Bitte wählen',
      pagination: 'Seitennavigation',
      paginationInfo: 'Seite {{page}} von {{totalPages}} · {{total}} Datensätze',
      copy: 'Kopieren',
      copied: 'Kopiert',
      actions: 'Aktionen',
      showDetails: 'Details einblenden',
      hideDetails: 'Details ausblenden',
    },
    validation: {
      required: 'Pflichtfeld',
      email: 'Bitte eine gültige E-Mail-Adresse angeben.',
    },
    errors: {
      requestFailed: 'Die Anfrage ist fehlgeschlagen',
      unexpectedTitle: 'Unerwarteter Fehler',
      unexpectedMessage: 'Es ist ein unerwarteter Fehler aufgetreten.',
      copyHint: '(Klick zum Kopieren)',
      copyId: 'ID kopieren',
      copied: 'Fehler-ID {{id}} kopiert.',
    },
    documentPricing: {
      overrideRequired:
        'Preise und finanzielle Konditionen dürfen mit dieser Rolle nicht geändert werden.',
    },
    permissions: {
      customerPricingReadOnly:
        'Preisgruppen, Rabatte und Skontokonditionen sind für diese Rolle schreibgeschützt.',
      deniedTitle: 'Kein Zugriff',
      deniedDescription: 'Für diese Ansicht fehlt die Berechtigung ({{permission}}).',
    },
    auth: {
      title: 'Anmeldung',
      subtitle: 'Melden Sie sich mit Ihren Zugangsdaten an.',
      email: 'E-Mail',
      password: 'Passwort',
      tenantSlug: 'Mandant',
      tenantSlugHint: 'Kurzname des Mandanten, z. B. musterfirma.',
      submit: 'Anmelden',
      logout: 'Abmelden',
      checking: 'Sitzung wird geprüft …',
      invalidCredentials: 'E-Mail oder Passwort ist falsch.',
      accountLocked: 'Das Konto ist vorübergehend gesperrt. Bitte später erneut versuchen.',
      tenantRequired: 'Diese E-Mail existiert in mehreren Mandanten. Bitte Mandant angeben.',
      twoFactor: {
        title: 'Zwei-Faktor-Bestätigung',
        description: 'Bitte den sechsstelligen Code aus Ihrer Authenticator-App eingeben.',
        emailDescription:
          'Bitte den sechsstelligen Code eingeben, der an {{email}} gesendet wurde.',
        useMethod: { TOTP: 'Authenticator-App verwenden', EMAIL: 'E-Mail-Code verwenden' },
        resend: 'Code erneut senden',
        resendIn: 'Erneut senden in {{seconds}} s',
        backupDescription: 'Bitte einen Ihrer Backup-Codes eingeben.',
        code: 'Bestätigungscode',
        backupCode: 'Backup-Code',
        submit: 'Bestätigen',
        invalid: 'Der Code ist ungültig oder abgelaufen.',
        useBackupCode: 'Backup-Code verwenden',
        useAuthenticator: 'Authenticator-App verwenden',
      },
    },
    customFields: {
      createTitle: 'Zusatzfeld anlegen',
      editTitle: 'Zusatzfeld bearbeiten',
      dialogDescription:
        'Zusatzfelder erweitern die Kundenstammdaten ohne Codeänderung. Schlüssel und Feldtyp sind nach dem Anlegen fest.',
      key: 'Schlüssel',
      keyHint: 'Technischer Name, z. B. kundenGruppe.',
      type: 'Feldtyp',
      label: 'Bezeichnung',
      labelEn: 'Bezeichnung (Englisch)',
      group: 'Gruppe',
      sortOrder: 'Sortierung',
      required: 'Pflichtfeld',
      showInList: 'In Liste anzeigen',
      filterable: 'Filterbar',
      marketingSegmentationAllowed: 'Für Newsletter-Segmentierung freigegeben',
      options: 'Optionen',
      addOption: 'Option hinzufügen',
      removeOption: 'Option entfernen',
      noOptions: 'Noch keine Optionen angelegt.',
      optionValue: 'Wert',
      optionLabel: 'Anzeige',
      created: 'Zusatzfeld angelegt.',
      updated: 'Zusatzfeld aktualisiert.',
      archived: 'Zusatzfeld archiviert.',
      archive: 'Archivieren',
      archiveTitle: 'Zusatzfeld archivieren',
      archiveDescription:
        'Das Feld "{{name}}" wird ausgeblendet. Bereits erfasste Werte bleiben erhalten.',
      saveError: 'Das Zusatzfeld konnte nicht gespeichert werden.',
      loadError: 'Die Zusatzfelder konnten nicht geladen werden.',
      filters: {
        action: 'Zusatzfelder',
        title: 'Nach Zusatzfeldern filtern',
        description: 'Textfelder suchen nach enthaltenem Text, andere Felder nach exaktem Wert.',
        reset: 'Zurücksetzen',
        clearField: 'Filter für {{field}} entfernen',
      },
      weeklySchedule: {
        empty: 'Keine Zeitfenster hinterlegt.',
        hint: 'Wählen Sie Wochentage und lokale Uhrzeiten. Mehrere Zeitfenster sind möglich. Die Endzeit muss am selben Tag nach der Anfangszeit liegen.',
        invalid: 'Bitte mindestens einen Wochentag sowie gültige Anfangs- und Endzeiten eingeben.',
        required: 'Mindestens ein vollständiges Zeitfenster ist erforderlich.',
      },
      types: {
        WEEKLY_SCHEDULE: 'Wochentage & Zeiten',
        TEXT: 'Text',
        TEXTAREA: 'Mehrzeiliger Text',
        NUMBER: 'Zahl',
        DATE: 'Datum',
        CHECKBOX: 'Checkbox',
        SELECT: 'Auswahl',
        MULTI_SELECT: 'Mehrfachauswahl',
      },
    },
    customers: {
      title: 'Kunden',
      subtitle: 'Stammdaten, Konditionen und Kontakthistorie aller Kunden.',
      searchPlaceholder: 'Suche nach Name, Nummer, Ort, USt-IdNr. …',
      searchLabel: 'Kunden durchsuchen',
      columnsMenu: 'Spalten',
      createTitle: 'Neuer Kunde',
      editTitle: 'Kunde bearbeiten',
      formDescription: 'Pflichtfelder sind markiert. Die Kundennummer wird bei Bedarf vergeben.',
      created: 'Kunde angelegt.',
      updated: 'Kunde gespeichert.',
      saveError: 'Der Kunde konnte nicht gespeichert werden.',
      actions: {
        create: 'Neuer Kunde',
        export: 'Export',
        logCall: 'Neues Telefonat erfassen',
        createQuote: 'Angebot erstellen',
        backToList: 'Zurück zur Liste',
      },
      tabs: {
        master: 'Stammdaten & Adressen',
        customFields: 'Zusatzfelder',
        history: 'Historie',
        documents: 'Belege',
        whatsapp: 'WhatsApp',
      },
      sections: {
        masterData: 'Stammdaten',
        address: 'Adresse',
        tax: 'Steuer & Identifikation',
        conditions: 'Zahlungskonditionen',
        customFields: 'Zusatzfelder',
      },
      detail: {
        since: 'Angelegt am {{date}}',
      },
      values: {
        days_one: '{{count}} Tag',
        days_other: '{{count}} Tage',
      },
      columns: {
        customerNumber: 'Nummer',
        displayName: 'Name',
        status: 'Status',
        industry: 'Branche',
        email: 'E-Mail',
        phone: 'Telefon',
        city: 'Ort',
        countryCode: 'Land',
        vatId: 'USt-IdNr.',
        ownerName: 'Betreuer',
        tags: 'Schlagworte',
      },
      fields: {
        type: 'Kundenart',
        status: 'Status',
        customerNumber: 'Kundennummer',
        customerNumberHint: 'Leer lassen für automatische Vergabe.',
        industry: 'Branche',
        companyName: 'Firmenname',
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'E-Mail',
        phone: 'Telefon',
        website: 'Website',
        street: 'Straße',
        houseNumber: 'Hausnummer',
        addressLine2: 'Adresszusatz',
        postalCode: 'PLZ',
        city: 'Ort',
        region: 'Region',
        countryCode: 'Land',
        vatId: 'USt-IdNr.',
        vatIdHint: 'Format wird geprüft, z. B. DE123456789.',
        vatIdStatus: 'Prüfstatus USt-IdNr.',
        taxNumber: 'Steuernummer',
        taxCategory: 'Steuerkategorie',
        datevDebtorAccount: 'DATEV-Debitorenkonto',
        gln: 'GLN',
        eoriNumber: 'EORI-Nummer',
        currency: 'Währung',
        documentLanguage: 'Belegsprache',
        paymentTermsDays: 'Zahlungsziel (Tage)',
        defaultDiscountPct: 'Rabatt',
        cashDiscountPct: 'Skonto',
        cashDiscountDays: 'Skontofrist (Tage)',
        deliveryTerms: 'Lieferbedingung',
        creditLimit: 'Kreditlimit',
        priceGroup: 'Preisgruppe',
        minRemainingShelfLifeDays: 'Mindestrestlaufzeit (Tage)',
        deliveryBlock: 'Liefersperre',
        dunningBlock: 'Mahnsperre',
        ownerName: 'Betreuer',
        tags: 'Schlagworte',
        tagsHint: 'Mehrere Werte durch Komma trennen.',
      },
      types: {
        COMPANY: 'Firma',
        PERSON: 'Privatperson',
      },
      statuses: {
        ACTIVE: 'Aktiv',
        PROSPECT: 'Interessent',
        BLOCKED: 'Gesperrt',
        INACTIVE: 'Inaktiv',
      },
      vatIdStatuses: {
        UNCHECKED: 'Ungeprüft',
        VALID: 'Gültig',
        INVALID: 'Ungültig',
        NOT_CHECKABLE: 'Nicht prüfbar',
        SERVICE_UNAVAILABLE: 'Dienst nicht erreichbar',
      },
      taxCategories: {
        DOMESTIC: 'Inland',
        EU_B2B: 'EU B2B',
        EU_B2C: 'EU B2C',
        THIRD_COUNTRY: 'Drittland',
        REVERSE_CHARGE_DOMESTIC: 'Reverse Charge (Inland)',
        TAX_EXEMPT: 'Steuerbefreit',
      },
      industries: {
        RETAIL: 'Einzelhandel',
        WHOLESALE: 'Großhandel',
        MANUFACTURING: 'Produktion',
        GASTRONOMY: 'Gastronomie',
        LOGISTICS: 'Logistik',
        HEALTHCARE: 'Gesundheitswesen',
        PUBLIC_SECTOR: 'Öffentlicher Sektor',
        CONSTRUCTION: 'Bau',
        AGRICULTURE: 'Landwirtschaft',
        SERVICES: 'Dienstleistung',
        OTHER: 'Sonstige',
      },
      documentTypes: {
        QUOTE: 'Angebot',
        ORDER: 'Auftrag',
        DELIVERY_NOTE: 'Lieferschein',
        INVOICE: 'Rechnung',
        CREDIT_NOTE: 'Gutschrift',
        CANCELLATION: 'Storno',
      },
      documentStatuses: {
        DRAFT: 'Entwurf',
        OPEN: 'Offen',
        CONFIRMED: 'Bestätigt',
        PARTIALLY_DELIVERED: 'Teilgeliefert',
        DELIVERED: 'Geliefert',
        POSTED: 'Festgeschrieben',
        PAID: 'Bezahlt',
        CANCELLED: 'Storniert',
      },
      filters: {
        status: 'Status',
        industry: 'Branche',
        tags: 'Schlagworte',
        vatIdStatus: 'USt-IdNr.',
        reset: 'Filter zurücksetzen',
      },
      states: {
        empty: 'Noch keine Kunden erfasst.',
        emptyFiltered: 'Keine Kunden für die aktuelle Auswahl.',
        error: 'Die Kundenliste konnte nicht geladen werden.',
        detailError: 'Der Kunde konnte nicht geladen werden.',
      },
      export: {
        csv: 'CSV herunterladen',
        xlsx: 'Excel herunterladen',
        success: 'Export erstellt.',
        error: 'Der Export ist fehlgeschlagen.',
      },
      delete: {
        title: 'Kunde löschen',
        description: 'Der Kunde "{{name}}" wird inaktiv gesetzt und ausgeblendet.',
        success: 'Kunde gelöscht.',
        error: 'Der Kunde konnte nicht gelöscht werden.',
      },
      addresses: {
        title: 'Abweichende Adressen',
        add: 'Adresse',
        createTitle: 'Adresse hinzufügen',
        editTitle: 'Adresse bearbeiten',
        description: 'Liefer- und Rechnungsadressen abweichend von der Hauptadresse.',
        type: 'Adressart',
        label: 'Bezeichnung',
        recipient: 'Empfänger',
        isDefault: 'Standard',
        contact: {
          title: 'Ansprechpartner dieser Adresse',
          hint: 'Optionale Angaben nur für diese Adresse. Es wird kein allgemeiner Ansprechpartner angelegt.',
          name: 'Name',
          position: 'Funktion / Position',
          phone: 'Telefon',
          mobile: 'Mobiltelefon',
          email: 'E-Mail',
          invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        },
        deliveryTermsOverride: 'Abweichende Lieferkondition',
        individualDeliveryTerms: 'Individuelle Lieferkondition',
        inheritedDeliveryTerms: 'Kundenstandard: {{value}}',
        deliveryTermsHint:
          'Ohne Abweichung wird automatisch die Lieferkondition aus dem Kundenstamm verwendet.',
        confirmRemoveDeliveryTerms:
          'Beim Wechsel des Adresstyps wird die abweichende Lieferkondition entfernt. Fortfahren?',
        empty: 'Keine abweichenden Adressen hinterlegt.',
        created: 'Adresse gespeichert.',
        updated: 'Adresse aktualisiert.',
        deleted: 'Adresse gelöscht.',
        delete: 'Adresse löschen',
        deleteTitle: 'Adresse löschen',
        deleteDescription: 'Die Adresse wird aus dem Kundenstamm entfernt.',
        error: 'Die Adresse konnte nicht gespeichert werden.',
        loadError: 'Die Adressen konnten nicht geladen werden.',
        types: {
          BILLING: 'Rechnungsadresse',
          SHIPPING: 'Lieferadresse',
          OTHER: 'Sonstige',
        },
      },
      contacts: {
        title: 'Ansprechpartner',
        add: 'Ansprechpartner',
        createTitle: 'Ansprechpartner hinzufügen',
        editTitle: 'Ansprechpartner bearbeiten',
        description: 'Kontaktpersonen für Angebote, Aufträge und Telefonate.',
        salutation: 'Anrede',
        title_label: 'Titel',
        position: 'Position',
        department: 'Abteilung',
        mobile: 'Mobil',
        isPrimary: 'Hauptkontakt',
        responsibilities: 'Zuständigkeiten',
        responsibilitiesHint: 'Mehrere Zuständigkeiten durch Komma trennen.',
        optOutMarketing: 'Von Marketing-Kommunikation ausschließen',
        empty: 'Keine Ansprechpartner hinterlegt.',
        created: 'Ansprechpartner gespeichert.',
        updated: 'Ansprechpartner aktualisiert.',
        deleted: 'Ansprechpartner gelöscht.',
        delete: 'Ansprechpartner löschen',
        deleteTitle: 'Ansprechpartner löschen',
        deleteDescription: 'Der Ansprechpartner wird aus dem Kundenstamm entfernt.',
        error: 'Der Ansprechpartner konnte nicht gespeichert werden.',
        loadError: 'Die Ansprechpartner konnten nicht geladen werden.',
      },
      notes: {
        add: 'Notiz erfassen',
        subject: 'Betreff',
        body: 'Notiz',
        created: 'Notiz gespeichert.',
        error: 'Die Notiz konnte nicht gespeichert werden.',
      },
      calls: {
        createTitle: 'Telefonat erfassen',
        description: 'Gesprächsergebnis, Dauer und Wiedervorlage dokumentieren.',
        direction: 'Richtung',
        outcome: 'Ergebnis',
        subject: 'Betreff',
        contact: 'Ansprechpartner',
        occurredAt: 'Zeitpunkt',
        durationSeconds: 'Dauer (Sekunden)',
        notes: 'Gesprächsnotiz',
        created: 'Telefonat gespeichert.',
        error: 'Das Telefonat konnte nicht gespeichert werden.',
        directions: {
          INBOUND: 'Eingehend',
          OUTBOUND: 'Ausgehend',
        },
        outcomes: {
          REACHED: 'Erreicht',
          NOT_REACHED: 'Nicht erreicht',
          CALLBACK: 'Rückruf vereinbart',
          ORDER_PLACED: 'Bestellung erhalten',
          COMPLAINT: 'Reklamation',
          NO_INTEREST: 'Kein Interesse',
        },
      },
      quotes: {
        createTitle: 'Angebot erstellen',
        description: 'Erzeugt ein Angebot im Entwurfsstatus mit den Konditionen des Kunden.',
        reference: 'Referenz',
        validDays: 'Gültigkeit (Tage)',
        submit: 'Angebot anlegen',
        created: 'Angebot erstellt.',
        error: 'Das Angebot konnte nicht erstellt werden.',
      },
      documents: {
        empty: 'Noch keine Belege vorhanden.',
        error: 'Die Belege konnten nicht geladen werden.',
      },
      activities: {
        empty: 'Noch keine Aktivitäten vorhanden.',
        error: 'Die Historie konnte nicht geladen werden.',
        types: {
          DOCUMENT: 'Belege',
          NOTE: 'Notizen',
          CALL: 'Telefonate',
        },
      },
      customFields: {
        title: 'Dynamische Zusatzfelder',
        subtitle: 'Felder werden direkt hier konfiguriert und stehen sofort zur Verfügung.',
        empty: 'Noch keine Zusatzfelder definiert.',
        saved: 'Zusatzfelder gespeichert.',
      },
    },
    inventory: {
      expiringWidget: {
        title: 'MHD-Warnungen',
        description: 'Chargen mit einer Restlaufzeit von höchstens {{days}} Tagen.',
        empty: 'Keine Charge läuft demnächst ab.',
        error: 'Die MHD-Warnungen konnten nicht geladen werden.',
        entry: 'Charge {{batch}} · {{quantity}} · Lagerplatz {{location}}',
        open: 'Öffnen',
        openBatch: 'Charge {{batch}} im Artikel öffnen',
        openProducts: 'Zu den Artikeln',
        showAll: 'Alle betroffenen Artikel anzeigen',
      },
    },
    products: {
      title: 'Artikel',
      subtitle: 'Stammdaten, Preise, Gebinde und Chargenbestände.',
      searchPlaceholder: 'Artikelnummer, Bezeichnung oder GTIN …',
      searchLabel: 'Artikel durchsuchen',
      createTitle: 'Artikel anlegen',
      editTitle: 'Artikel bearbeiten',
      formDescription: 'Alle Angaben gelten für den aktuellen Mandanten.',
      created: 'Artikel angelegt.',
      updated: 'Artikel gespeichert.',
      saveError: 'Der Artikel konnte nicht gespeichert werden.',
      columnsMenu: 'Spalten',
      decimals: {
        hint: 'Punkt oder Komma als Dezimalzeichen verwenden: 47,45 und 47.45 sind gleich. 47, oder 47. wird als 47 übernommen. Keine Tausendertrennzeichen eingeben.',
        moneyError:
          'Bitte eine gültige Zahl mit höchstens 4 Nachkommastellen eingeben; Punkt und Komma sind erlaubt.',
        percentError:
          'Bitte einen Wert von 0 bis 100 mit höchstens 6 Nachkommastellen eingeben; Punkt und Komma sind erlaubt.',
        quantityError:
          'Bitte eine nicht negative Zahl mit höchstens 6 Nachkommastellen eingeben; Punkt und Komma sind erlaubt.',
      },
      texts: {
        translatedName: 'Bezeichnung ({{language}})',
        translatedDescription: 'Beschreibung ({{language}})',
        languageLabel: 'Sprache der Artikeltexte',
        optionalHint:
          'Übersetzungen sind optional. Ohne Übersetzung werden die deutschen Texte verwendet.',
        validationSummary:
          'Bitte prüfen Sie die markierten Felder. Ihre Eingaben bleiben erhalten.',
        nameRequired: 'Bitte geben Sie die deutsche Bezeichnung ein.',
        nameTooLong: 'Die Bezeichnung darf höchstens 200 Zeichen enthalten.',
        descriptionTooLong: 'Die Beschreibung darf höchstens 4000 Zeichen enthalten.',
      },
      tabs: {
        master: 'Stammdaten & Preise',
        images: 'Bilder',
        priceTiers: 'Staffelpreise',
        specifications: 'Spezifikationen',
        packagings: 'Gebinde & Verpackungen',
        batches: 'Chargen & MHD',
        movements: 'Lagerhistorie',
      },
      detail: {
        stockSummary: 'Bestand {{stock}} {{unit}} · verfügbar {{available}} {{unit}}',
      },
      badges: {
        batchManaged: 'Chargenpflicht',
        belowMinStock: 'Meldebestand unterschritten',
      },
      actions: {
        create: 'Artikel anlegen',
        export: 'Export',
        bulkPrice_one: 'Preise ändern ({{count}})',
        bulkPrice_other: 'Preise ändern ({{count}})',
        adjustStock: 'Bestand korrigieren',
        backToList: 'Zurück zur Liste',
      },
      export: {
        csv: 'CSV herunterladen',
        xlsx: 'Excel herunterladen',
        success: 'Export erstellt.',
        error: 'Der Export ist fehlgeschlagen.',
      },
      states: {
        empty: 'Noch keine Artikel vorhanden.',
        emptyFiltered: 'Keine Artikel entsprechen den aktuellen Filtern.',
        error: 'Die Artikel konnten nicht geladen werden.',
        detailError: 'Der Artikel konnte nicht geladen werden.',
      },
      selection: {
        toggleAll: 'Alle Artikel auf dieser Seite auswählen',
        toggleRow: '{{name}} auswählen',
      },
      columns: {
        icon: 'Art',
        image: 'Bild',
        articleNumber: 'Artikelnummer',
        name: 'Bezeichnung',
        productGroup: 'Warengruppe',
        productGroupLegacy: 'Warengruppe (Kompatibilitätsfeld)',
        stock: 'Bestand',
        available: 'Verfügbar',
        listPrice: 'Standard-VK',
        purchasePrice: 'EK',
        batches: 'Chargen',
        status: 'Status',
        tags: 'Schlagwörter',
      },
      batchBadge: {
        count_one: '{{count}} Charge',
        count_other: '{{count}} Chargen',
        expiring_one: '{{count}} MHD-Warnung',
        expiring_other: '{{count}} MHD-Warnungen',
      },
      filters: {
        criticalStock: 'Kritischer Bestand',
        expiring: 'MHD-Warnungen (< {{days}} Tage)',
        activeOnly: 'Nur aktive Artikel',
        status: 'Status',
        type: 'Artikelart',
        productGroup: 'Warengruppe',
        batchManaged: 'Chargenführung',
        batchManagedOnly: 'Nur chargengeführt',
        batchManagedNone: 'Ohne Chargenführung',
        reset: 'Filter zurücksetzen',
      },
      sections: {
        base: 'Stammdaten',
        prices: 'Preise & Disposition',
        logistics: 'Logistik & Zoll',
        batches: 'Chargen & MHD',
        customFields: 'Zusatzfelder',
      },
      fields: {
        articleNumber: 'Artikelnummer',
        articleNumberHint: 'Leer lassen für die automatische Vergabe aus dem Nummernkreis.',
        name: 'Bezeichnung',
        nameEn: 'Bezeichnung (EN)',
        description: 'Beschreibung',
        type: 'Artikelart',
        status: 'Status',
        ean: 'GTIN/EAN',
        manufacturerNumber: 'Herstellernummer',
        productGroup: 'Warengruppe',
        baseUnit: 'Basiseinheit',
        taxRateType: 'Steuersatz',
        taxRatePct: 'Steuersatz (%)',
        currency: 'Währung',
        listPrice: 'Verkaufspreis',
        purchasePrice: 'Einkaufspreis',
        minMarginPct: 'Mindestmarge (%)',
        marginHint: 'Aktuelle Marge: {{value}}',
        weightNetKg: 'Nettogewicht (kg)',
        weightGrossKg: 'Bruttogewicht (kg)',
        commodityCode: 'Warennummer',
        commodityCodeHint: 'Zolltarifnummer mit 8, 10 oder 11 Stellen.',
        countryOfOrigin: 'Ursprungsland',
        minStock: 'Meldebestand',
        reorderPoint: 'Bestellpunkt',
        targetStock: 'Sollbestand',
        leadTimeDays: 'Wiederbeschaffung (Tage)',
        isBatchManaged: 'Chargenpflichtig',
        isShelfLifeManaged: 'MHD-geführt',
        shelfLifeDays: 'Haltbarkeit (Tage)',
        shelfLifeDaysHint: 'Grundlage für die MHD-Vorbelegung neuer Chargen.',
        minRemainingShelfLifeDays: 'Mindestrestlaufzeit (Tage)',
        pickingStrategy: 'Entnahmestrategie',
        tags: 'Schlagwörter',
        tagsHint: 'Mehrere Werte mit Komma trennen.',
      },
      statuses: {
        ARCHIVED: 'Archiviert',
        ACTIVE: 'Aktiv',
        PHASE_OUT: 'Auslaufend',
        DISCONTINUED: 'Ausgelistet',
        BLOCKED: 'Gesperrt',
      },
      types: {
        STOCK: 'Lagerartikel',
        NON_STOCK: 'Nicht lagerhaltig',
        SERVICE: 'Dienstleistung',
        SET: 'Stückliste',
        DEPOSIT: 'Pfand',
      },
      taxRateTypes: {
        STANDARD: 'Regelsatz',
        REDUCED: 'Ermäßigt',
        ZERO: 'Steuerfrei',
      },
      pickingStrategies: {
        FEFO: 'FEFO (kürzestes MHD zuerst)',
        FIFO: 'FIFO (ältester Zugang zuerst)',
        MANUAL: 'Manuelle Auswahl',
      },
      images: {
        title: 'Artikelbilder',
        gallery: 'Bildergalerie',
        empty: 'Für diesen Artikel sind noch keine Bilder hinterlegt.',
        loadError: 'Die Artikelbilder konnten nicht geladen werden.',
        drop: 'Bilder hier ablegen oder auswählen',
        detected: '{{count}} Datei(en) erkannt',
        remaining: 'Noch {{count}} Bild(er) möglich · JPEG, PNG, WebP oder AVIF',
        choose: 'Dateien auswählen',
        camera: 'Kamera verwenden',
        invalidSelection:
          'Mindestens eine Datei ist ungültig oder die maximale Bildanzahl wäre überschritten.',
        removePending: '{{name}} aus der Auswahl entfernen',
        partialUploadError:
          '{{count}} Bild(er) konnten nicht hochgeladen werden. Der Artikel wurde gespeichert; versuchen Sie nur diese Dateien erneut.',
        limits: 'JPEG, PNG, WebP oder AVIF · maximal 20 MB · bis zu {{count}} Bilder',
        count: '{{current}} von {{max}} Bildern',
        progress: 'Upload: {{progress}} %',
        uploadStates: {
          PENDING: 'Wartet',
          UPLOADING: 'Wird hochgeladen: {{progress}} %',
          SUCCESS: 'Hochgeladen',
          FAILED: 'Fehlgeschlagen – beim Speichern erneut versuchen',
        },
        uploaded: '{{count}} Bild(er) hochgeladen.',
        uploadError: 'Die Bilder konnten nicht hochgeladen werden.',
        emptyFile: 'Die Datei ist leer.',
        fileTooLarge: 'Die Datei überschreitet 20 MB.',
        unsupportedFormat: 'Nur JPEG, PNG, WebP und AVIF sind zulässig.',
        tooMany: 'Pro Artikel sind höchstens {{count}} Bilder zulässig.',
        selection: 'Auswahl',
        select: '{{title}} auswählen',
        primary: 'Hauptbild',
        makePrimary: 'Als Hauptbild festlegen',
        primarySet: 'Hauptbild geändert.',
        fullscreen: 'Vollbild',
        original: 'Original ansehen',
        replace: 'Bild ersetzen',
        replaced: 'Bild ersetzt.',
        deleteTitle: 'Artikelbild löschen?',
        deleteDescription:
          '„{{name}}“ wird einschließlich Original und Darstellungsvarianten dauerhaft entfernt.',
        deleted: 'Bild gelöscht.',
        deleteError: 'Das Bild konnte nicht gelöscht werden.',
        sorted: 'Bildreihenfolge gespeichert.',
        sortError: 'Die Bildreihenfolge konnte nicht gespeichert werden.',
        editTitle: 'Bilddaten bearbeiten',
        editDescription: 'Titel und Alternativtext gelten für die barrierefreie Darstellung.',
        imageTitle: 'Bildtitel',
        altText: 'Alternativtext',
        altHint: 'Beschreibt den sichtbaren Bildinhalt kurz und sachlich.',
        updated: 'Bilddaten gespeichert.',
        updateError: 'Das Bild konnte nicht aktualisiert werden.',
        retrySuccess: 'Bildvarianten wurden neu erzeugt.',
      },
      categories: {
        action: 'Kategorien verwalten',
        title: 'Artikelkategorien',
        description:
          'Mandantenbezogene Kategorien hierarchisch strukturieren und Artikeln zuordnen.',
        tree: 'Kategoriebaum',
        editor: 'Kategorie bearbeiten',
        search: 'Kategorien durchsuchen …',
        showInactive: 'Inaktive Kategorien anzeigen',
        empty: 'Noch keine passenden Kategorien vorhanden.',
        loadError: 'Die Kategorien konnten nicht geladen werden.',
        createRoot: 'Hauptkategorie anlegen',
        createChild: 'Unterkategorie unter {{name}} anlegen',
        createTitle: 'Kategorie anlegen',
        editTitle: 'Kategorie bearbeiten',
        expand: '{{name}} aufklappen',
        collapse: '{{name}} zuklappen',
        productCount: '{{count}} Artikel',
        inactive: 'Inaktiv',
        active: 'Aktiv',
        name: 'Bezeichnung',
        nameEn: 'Bezeichnung (Englisch)',
        categoryDescription: 'Beschreibung',
        parent: 'Übergeordnete Kategorie',
        root: 'Oberste Ebene',
        sortOrder: 'Sortierreihenfolge',
        archive: 'Archivieren',
        archiveTitle: 'Artikelkategorie archivieren?',
        archiveDescription:
          '„{{name}}“ wird deaktiviert und aus der aktiven Kategorienavigation entfernt.',
        archived: 'Kategorie archiviert.',
        archiveError: 'Die Kategorie konnte nicht archiviert werden.',
        created: 'Kategorie angelegt.',
        updated: 'Kategorie gespeichert.',
        saveError: 'Die Kategorie konnte nicht gespeichert werden.',
        assignments: 'Kategorien',
        selected: '{{count}} Kategorie(n) ausgewählt',
        primary: 'Primäre Kategorie',
        makePrimary: '{{name}} als primäre Kategorie festlegen',
      },
      batchStatuses: {
        FREE: 'Frei',
        QUARANTINE: 'Quarantäne',
        BLOCKED: 'Gesperrt',
        EXPIRED: 'Abgelaufen',
        DEPLETED: 'Aufgebraucht',
      },
      movementTypes: {
        GOODS_RECEIPT: 'Wareneingang',
        GOODS_ISSUE: 'Warenausgang',
        TRANSFER_IN: 'Umlagerung Zugang',
        TRANSFER_OUT: 'Umlagerung Abgang',
        ADJUSTMENT: 'Korrektur',
        INVENTORY_COUNT: 'Inventur',
        SCRAP: 'Verschrottung',
        RETURN_IN: 'Kundenretoure',
        RETURN_OUT: 'Lieferantenretoure',
      },
      referenceTypes: {
        MANUAL: 'Manuell',
        ORDER: 'Auftrag',
        DELIVERY_NOTE: 'Lieferschein',
        INVOICE: 'Rechnung',
        PURCHASE_ORDER: 'Bestellung',
        INVENTORY: 'Inventur',
        PRODUCTION: 'Produktion',
      },
      units: {
        PCE: 'Stück',
        KGM: 'kg',
        GRM: 'g',
        LTR: 'l',
        MLT: 'ml',
        MTR: 'm',
        MTQ: 'm³',
        MTK: 'm²',
        PA: 'Paket',
      },
      packagingUnits: {
        BX: 'Karton',
        CT: 'Umkarton',
        PF: 'Palette',
        PK: 'Gebinde',
        TU: 'Tray',
        BG: 'Beutel',
        CS: 'Kiste',
      },
      priceTiers: {
        add: 'Staffel hinzufügen',
        remove: 'Staffel entfernen',
        empty: 'Noch keine Staffelpreise hinterlegt.',
        saved: 'Staffelpreise gespeichert.',
        saveError: 'Die Staffelpreise konnten nicht gespeichert werden.',
        calculate: 'Rabatt anwenden',
        calculatorHint: 'Der Rabatt wird auf den Standard-VK gerechnet.',
        columns: {
          priceGroup: 'Preisgruppe',
          minQuantity: 'Ab Menge',
          unitPrice: 'Einzelpreis',
          discountPct: 'Rabatt (%)',
          margin: 'Marge',
          validFrom: 'Gültig ab',
          validTo: 'Gültig bis',
        },
      },
      packagings: {
        add: 'Gebinde hinzufügen',
        remove: 'Gebinde entfernen',
        empty: 'Noch keine Gebinde hinterlegt.',
        description: 'Der Umrechnungsfaktor beschreibt die Menge in {{unit}} je Gebinde.',
        saved: 'Gebinde gespeichert.',
        saveError: 'Die Gebinde konnten nicht gespeichert werden.',
        fields: {
          code: 'Schlüssel',
          name: 'Bezeichnung',
          unitCode: 'Gebindeart',
          factor: 'Umrechnungsfaktor',
          factorHint: 'Menge in {{unit}} je Gebinde.',
          ean: 'Gebinde-GTIN',
          weightGrossKg: 'Bruttogewicht (kg)',
          lengthMm: 'Länge (mm)',
          widthMm: 'Breite (mm)',
          heightMm: 'Höhe (mm)',
          minOrderQuantity: 'Mindestbestellmenge',
          orderStepQuantity: 'Bestellstaffelung',
          isSalesDefault: 'Standard im Verkauf',
          isPurchaseDefault: 'Standard im Einkauf',
        },
      },
      batches: {
        create: 'Charge einlagern',
        empty: 'Noch keine Chargen vorhanden.',
        error: 'Die Chargen konnten nicht geladen werden.',
        notManaged: 'Dieser Artikel wird nicht chargengeführt.',
        includeDepleted: 'Aufgebrauchte Chargen anzeigen',
        totalRemaining: 'Gesamtbestand {{value}} {{unit}}',
        daysLeft_one: 'noch {{count}} Tag',
        daysLeft_other: 'noch {{count}} Tage',
        block: 'Sperren',
        release: 'Freigeben',
        blocked: 'Charge {{batch}} gesperrt.',
        released: 'Charge {{batch}} freigegeben.',
        blockTitle: 'Charge sperren',
        blockDescription: 'Die Charge {{batch}} wird für Entnahmen gesperrt.',
        blockReason: 'Begründung',
        releaseReason: 'Freigabe nach Prüfung',
        updateError: 'Die Charge konnte nicht aktualisiert werden.',
        customFieldsEditTitle: 'Chargen-Zusatzfelder bearbeiten',
        customFieldsEditDescription: 'Zusatzangaben für Charge {{batch}}.',
        customFieldsSaved: 'Chargen-Zusatzfelder gespeichert.',
        levels: {
          EXPIRED: 'Abgelaufen',
          CRITICAL: 'Kritisch',
          WARNING: 'Warnung',
          OK: 'Unkritisch',
        },
        columns: {
          batchNumber: 'Charge',
          bestBeforeDate: 'MHD',
          remainingShelfLife: 'Restlaufzeit',
          remaining: 'Restmenge',
          storageLocation: 'Lagerplatz',
          status: 'Status',
          actions: 'Aktionen',
        },
      },
      batchDialog: {
        title: 'Charge einlagern',
        description: 'Zugangsbuchung für {{name}}.',
        submit: 'Charge einlagern',
        created: 'Charge {{batch}} eingelagert.',
        error: 'Die Charge konnte nicht angelegt werden.',
        fields: {
          batchNumber: 'Chargennummer',
          quantity: 'Menge ({{unit}})',
          productionDate: 'Produktionsdatum',
          bestBeforeDate: 'Mindesthaltbarkeitsdatum',
          bestBeforeHint: 'Vorschlag aus der Haltbarkeit von {{days}} Tagen.',
          storageLocation: 'Lagerplatz',
          warehouseCode: 'Lager',
          supplierBatchNumber: 'Lieferantencharge',
          certificateRef: 'Zertifikat',
          countryOfOrigin: 'Ursprungsland',
          unitCost: 'Einstandspreis',
          referenceType: 'Referenzart',
          notes: 'Notizen',
        },
      },
      adjustment: {
        title: 'Bestandskorrektur',
        description: '{{name}} · aktueller Bestand {{stock}}',
        modeLabel: 'Art der Buchung',
        modes: {
          DELTA: 'Korrekturmenge',
          COUNT: 'Inventurbestand',
        },
        submit: 'Buchen',
        success: 'Bestand korrigiert.',
        newStock: 'Neuer Bestand: {{value}}',
        error: 'Die Buchung ist fehlgeschlagen.',
        fields: {
          quantity: 'Korrekturmenge',
          quantityHint: 'Positive Werte buchen zu, negative ab.',
          countedQuantity: 'Gezählter Bestand',
          countedQuantityHint: 'Die Differenz zum Buchbestand wird automatisch gebucht.',
          batch: 'Charge',
          warehouseCode: 'Lager',
          reason: 'Begründung',
          reasonHint: 'Pflichtangabe, mindestens {{min}} Zeichen (revisionssicher).',
        },
      },
      movements: {
        description: 'Alle Bestandsbewegungen in revisionssicherer Reihenfolge.',
        empty: 'Noch keine Bewegungen gebucht.',
        error: 'Die Lagerhistorie konnte nicht geladen werden.',
        filterType: 'Bewegungsart',
        balanceAfter: 'Bestand danach: {{value}}',
        entry: '{{date}} · {{user}} · {{reference}}',
      },
      bulkPrice: {
        title: 'Preise aktualisieren',
        description: 'Die Änderung wird auf {{count}} ausgewählte Artikel angewendet.',
        submit: 'Preise aktualisieren',
        success: '{{updated}} Artikel aktualisiert, {{skipped}} übersprungen.',
        error: 'Die Preisaktualisierung ist fehlgeschlagen.',
        targets: {
          LIST_PRICE: 'Verkaufspreis',
          PURCHASE_PRICE: 'Einkaufspreis',
        },
        modes: {
          PERCENT: 'Prozentual ändern',
          ABSOLUTE: 'Betrag addieren',
          SET: 'Festpreis setzen',
        },
        valueLabels: {
          PERCENT: 'Änderung in Prozent',
          ABSOLUTE: 'Änderung als Betrag',
          SET: 'Neuer Preis',
        },
        fields: {
          target: 'Preisfeld',
          mode: 'Berechnung',
          roundTo: 'Nachkommastellen',
          reason: 'Begründung',
          reasonHint: 'Wird revisionssicher im Änderungsprotokoll gespeichert.',
        },
      },
    },
    documents: {
      packaging: {
        baseUnitPriceColumn: 'Stück-/Basispreis',
        baseUnitPriceLabel: 'Preis je {{unit}}',
        baseUnitPriceInvalid:
          'Bitte einen gültigen Preis mit höchstens vier Nachkommastellen eingeben. Auch der umgerechnete Gebindepreis muss im zulässigen Bereich liegen.',
        baseUnitPrice: 'Preis je {{unit}}: {{price}}',
        label: 'Einheit / Gebinde',
        conversion: '{{quantity}} {{packaging}} = {{baseQuantity}} {{baseUnit}}',
        historic: 'gespeichert',
        loading: 'Gebinde werden geladen …',
        loadError: 'Gebinde konnten nicht geladen werden.',
        pricing: 'Preis wird ermittelt …',
        priceError: 'Preis nicht bestätigt. Bitte Menge und Gebinde prüfen und erneut versuchen.',
        saveBlocked:
          'Bitte Gebinde laden und die Preisermittlung erfolgreich abschließen, bevor Sie speichern.',
        invalid: 'Bitte eine gültige Menge eingeben.',
        minimum: 'Die Mindestmenge beträgt {{value}} der gewählten Einheit.',
        step: 'Die Menge muss ein Vielfaches von {{value}} der gewählten Einheit sein.',
      },
      legacyCustomFieldsNotice:
        'Für die Zusatzfelder dieses Altbelegs fehlen historische Definitionen. Sie werden nicht neu interpretiert. Bitte den ursprünglichen Ausdruck verwenden.',
      title: 'Belege',
      subtitle: 'Angebote, Aufträge, Lieferscheine und Rechnungen entlang der Belegkette.',
      tabs: {
        all: 'Alle',
      },
      catalog: {
        mode: 'Positionsansicht',
        tab: 'Katalog',
        positionsTab: 'Positionen',
        customerRequired: 'Bitte zuerst einen Kunden auswählen.',
        selectCustomerHint:
          'Sie können den Katalog durchsuchen. Für verbindliche Preise und das Hinzufügen ist zuerst ein Kunde erforderlich.',
        categories: 'Kategorien',
        categoriesDescription: 'Kategorie wählen, um den Katalog einzugrenzen.',
        categoriesError: 'Die Kategorien konnten nicht geladen werden.',
        allProducts: 'Alle Artikel',
        expandCategory: '{{name}} aufklappen',
        collapseCategory: '{{name}} zuklappen',
        breadcrumb: 'Kategoriepfad',
        search: 'Artikelnummer, EAN, Name, Beschreibung oder Schlagwort …',
        filters: 'Filter',
        reset: 'Filter zurücksetzen',
        activeOnly: 'Nur aktive Artikel',
        availableOnly: 'Nur verfügbare Artikel',
        productType: 'Artikelart',
        allTypes: 'Alle Artikelarten',
        stockStatus: 'Lagerstatus',
        allStockStatuses: 'Alle Lagerstatus',
        stockStatuses: {
          AVAILABLE: 'Verfügbar',
          LOW: 'Niedriger Bestand',
          OUT_OF_STOCK: 'Nicht verfügbar',
          NOT_MANAGED: 'Nicht lagergeführt',
        },
        manufacturer: 'Hersteller',
        minPrice: 'Preis von',
        maxPrice: 'Preis bis',
        sort: 'Sortierung',
        sortOptions: {
          name_asc: 'Name aufsteigend',
          name_desc: 'Name absteigend',
          articleNumber_asc: 'Artikelnummer aufsteigend',
          articleNumber_desc: 'Artikelnummer absteigend',
          price_asc: 'Preis aufsteigend',
          price_desc: 'Preis absteigend',
          stock_asc: 'Bestand aufsteigend',
          stock_desc: 'Bestand absteigend',
          lastUsed_desc: 'Zuletzt verwendet',
          updatedAt_desc: 'Zuletzt geändert',
        },
        grid: 'Rasteransicht',
        list: 'Listenansicht',
        loadError: 'Der Katalog konnte nicht geladen werden.',
        empty: 'Keine Artikel entsprechen der Auswahl.',
        batch: 'Charge',
        ean: 'EAN',
        available: 'Verfügbar',
        reserved: 'Reserviert',
        notManaged: 'Nicht lagergeführt',
        customerPrice: 'Kundenpreis',
        listPrice: 'Listenpreis',
        packaging: 'Verpackungseinheit',
        baseUnit: 'Basiseinheit ({{unit}})',
        baseQuantity: 'Entspricht {{quantity}} {{unit}} Basismenge',
        quantity: 'Menge',
        decrease: 'Menge verringern',
        increase: 'Menge erhöhen',
        add: 'Hinzufügen',
        addedShort: 'Hinzugefügt',
        added: 'Artikel zum Auftrag hinzugefügt.',
        addError: 'Der Artikel konnte nicht hinzugefügt werden.',
        inOrder: 'Im Auftrag: {{quantity}} {{unit}}',
        shortfall: 'Die gewünschte Basismenge übersteigt den verfügbaren Bestand.',
      },
      types: {
        QUOTE: 'Angebot',
        ORDER: 'Auftrag',
        DELIVERY_NOTE: 'Lieferschein',
        INVOICE: 'Rechnung',
        CANCELLATION: 'Stornorechnung',
        CREDIT_NOTE: 'Gutschrift',
        PURCHASE_ORDER: 'Bestellung',
      },
      statuses: {
        DRAFT: 'Entwurf',
        SENT: 'Versendet',
        ACCEPTED: 'Angenommen',
        REJECTED: 'Abgelehnt',
        CONFIRMED: 'Bestätigt',
        IN_PROGRESS: 'In Bearbeitung',
        PARTIALLY_PROCESSED: 'Teilweise bearbeitet',
        SHIPPED: 'Versandt',
        COMPLETED: 'Abgeschlossen',
        POSTED: 'Festgeschrieben',
        CANCELLED: 'Storniert',
      },
      paymentStatuses: {
        OPEN: 'Offen',
        PARTIALLY_PAID: 'Teilbezahlt',
        PAID: 'Bezahlt',
        OVERDUE: 'Überfällig',
        WRITTEN_OFF: 'Ausgebucht',
      },
      taxStrategies: {
        REGULAR: 'Regelbesteuerung',
        REVERSE_CHARGE: 'Reverse Charge (§ 13b UStG)',
        INTRA_COMMUNITY: 'Innergemeinschaftliche Lieferung',
        EXPORT_NON_EU: 'Ausfuhrlieferung (Drittland)',
      },
      taxDetermination: {
        title: 'Nachvollziehbare Steuerermittlung',
        loading: 'Steuerempfehlung wird geprüft …',
        unavailable: 'Steuerempfehlung derzeit nicht verfügbar',
        selectCustomer:
          'Kunde, Lieferart und Positionen auswählen, um eine Empfehlung zu erhalten.',
        suggestion: 'Empfehlung',
        applySuggestion: 'Empfehlung übernehmen',
        reasonsTitle: 'Entscheidungsgründe',
        actionsTitle: 'Offene Prüfungen und Nachweise',
        noActions: 'Keine offenen Prüfschritte erkannt.',
        overrideReason: 'Begründung der abweichenden Entscheidung',
        overridePlaceholder: 'Fachlich geprüften Grund dokumentieren (mindestens 10 Zeichen)',
        overrideForbidden: 'Nur berechtigte Rollen dürfen von der Empfehlung abweichen.',
        disclaimer:
          'Die Empfehlung unterstützt die Belegprüfung, ersetzt aber keine steuerliche oder rechtliche Beratung. Sonderfälle wie Reihengeschäfte und Dreiecksgeschäfte müssen fachlich geprüft werden.',
        deliveryMode: 'Lieferart',
        deliveryModes: {
          SHIPMENT: 'Versand',
          PICKUP: 'Abholung',
          UNKNOWN: 'Noch nicht festgelegt',
        },
        assessments: {
          ELIGIBLE: 'Voraussetzungen erkannt',
          NOT_ELIGIBLE: 'Voraussetzungen nicht erfüllt',
          REVIEW_REQUIRED: 'Prüfung erforderlich',
        },
        reasons: {
          CROSS_BORDER_EU_DESTINATION: 'Lieferziel liegt in einem anderen EU-Mitgliedstaat.',
          DOMESTIC_DESTINATION: 'Lieferziel liegt im Land des Verkäufers.',
          DESTINATION_NOT_EU: 'Lieferziel liegt außerhalb der EU.',
          DESTINATION_MISSING: 'Das tatsächliche Lieferziel ist noch nicht bestätigt.',
          SELLER_NOT_EU: 'Der Verkäufer war am Belegdatum kein EU-Unternehmen.',
          CUSTOMER_IS_COMPANY: 'Der Kunde ist als Unternehmen geführt.',
          CUSTOMER_NOT_COMPANY: 'Der Kunde ist nicht als Unternehmen geführt.',
          CUSTOMER_CONFIGURED_EU_B2B: 'Der Kunde ist als EU-B2B-Kunde konfiguriert.',
          CUSTOMER_NOT_CONFIGURED_EU_B2B: 'Die Kunden-Steuerkategorie ist nicht EU-B2B.',
          VAT_ID_VALID_AND_CURRENT: 'Die aktuelle USt-IdNr. besitzt einen gültigen VIES-Nachweis.',
          VAT_ID_MISSING: 'Beim Kunden fehlt eine USt-IdNr.',
          VAT_ID_INVALID: 'Die letzte USt-IdNr.-Prüfung war nicht gültig.',
          VAT_ID_COUNTRY_MISMATCH: 'Das USt-IdNr.-Präfix passt nicht zum Lieferland.',
          VAT_VALIDATION_MISSING: 'Es liegt noch keine VIES-Prüfung vor.',
          VAT_VALIDATION_STALE:
            'Der VIES-Nachweis ist veraltet oder stammt aus einer alten Zuordnung.',
          VAT_VALIDATION_UNAVAILABLE:
            'VIES war bei der letzten Prüfung nicht erreichbar; dies gilt nicht als gültiger Nachweis.',
          VAT_ID_CHANGED_SINCE_DOCUMENT_SNAPSHOT:
            'Die USt-IdNr. wurde seit dem letzten Beleg-Snapshot geändert.',
          BILLING_AND_DESTINATION_DIFFER:
            'Rechnungs- und tatsächliches Lieferland unterscheiden sich.',
          GOODS_SUPPLY: 'Die Positionen wurden als Warenlieferung erkannt.',
          SERVICE_SUPPLY_REVIEW: 'Leistungen benötigen eine eigene Orts- und Steuerprüfung.',
          MIXED_SUPPLY_REVIEW:
            'Waren und Leistungen sind gemischt und müssen getrennt geprüft werden.',
          SUPPLY_TYPE_UNKNOWN: 'Die Art der Lieferung oder Leistung ist noch nicht eindeutig.',
          PICKUP_REVIEW:
            'Bei Abholung ist die grenzüberschreitende Warenbewegung gesondert nachzuweisen.',
          DELIVERY_MODE_UNKNOWN: 'Die Lieferart ist noch nicht festgelegt.',
          TRANSPORT_EVIDENCE_AVAILABLE: 'Ein verknüpfter Versand- oder Zollnachweis ist vorhanden.',
          TRANSPORT_EVIDENCE_REQUIRED: 'Für die Steuerbefreiung fehlt noch ein Versandnachweis.',
          EXISTING_EXPORT_CONFIGURATION:
            'Die Drittland-Konfiguration des Kunden wurde berücksichtigt.',
          EXISTING_REVERSE_CHARGE_CONFIGURATION:
            'Die bestehende Reverse-Charge-Konfiguration wurde berücksichtigt.',
          MASTER_FACTS_INCOMPLETE:
            'Für die Steuerprüfung fehlen aktuelle Stamm- oder Adressangaben.',
          SPECIAL_CASE_REVIEW:
            'Dieser Fall wird nicht automatisch entschieden und benötigt eine Fachprüfung.',
        },
        actions: {
          VERIFY_VAT_ID: 'USt-IdNr. aktuell über VIES prüfen.',
          CONFIRM_DESTINATION: 'Tatsächliches Lieferziel bestätigen.',
          COLLECT_TRANSPORT_EVIDENCE:
            'Lieferschein oder belastbaren Versand-/Zollnachweis verknüpfen.',
          REVIEW_SUPPLY_TYPE: 'Waren- und Leistungsart fachlich prüfen.',
          REVIEW_PICKUP_OR_SPECIAL_CASE:
            'Abhol- oder Sonderfall durch eine Fachrolle prüfen lassen.',
          COMPLETE_MASTER_FACTS: 'Die angegebenen Stamm- oder Adressangaben prüfen und ergänzen.',
          PROVIDE_OVERRIDE_REASON: 'Abweichende Steuerentscheidung begründen.',
        },
      },
      paymentMethods: {
        INVOICE: 'Rechnung (Zahlung auf Ziel)',
        PREPAYMENT: 'Vorkasse',
        CASH: 'Barzahlung',
      },
      languages: {
        tr: 'Türkisch',
        es: 'Spanisch',
        de: 'Deutsch',
        en: 'Englisch',
        fr: 'Französisch',
      },
      languageFallback:
        'Für diese Sprache fehlt eine integrierte Vorlage. Ohne eigene Mandantenvorlage wird Deutsch verwendet.',
      columns: {
        number: 'Belegnummer',
        type: 'Belegart',
        customer: 'Kunde',
        documentDate: 'Belegdatum',
        dueDate: 'Fällig',
        status: 'Status',
        grossTotal: 'Brutto',
      },
      filters: {
        search: 'Belege durchsuchen',
        searchPlaceholder: 'Belegnummer, Referenz oder Kunde …',
        status: 'Status',
        allStatuses: 'Alle Status',
        dateFrom: 'Belegdatum von',
        dateTo: 'Belegdatum bis',
        payment: {
          ALL: 'Alle',
          OPEN: 'Offen',
          OVERDUE: 'Überfällig',
          PAID: 'Bezahlt',
        },
      },
      actions: {
        create: 'Beleg anlegen',
        lock: 'Festschreiben',
        sendEmail: 'Per E-Mail senden',
        convertTo: {
          QUOTE: 'In Angebot umwandeln',
          ORDER: 'In Auftrag umwandeln',
          DELIVERY_NOTE: 'Lieferschein erstellen',
          INVOICE: 'Rechnung schreiben',
          CANCELLATION: 'Stornieren',
          CREDIT_NOTE: 'Gutschrift erstellen',
          PURCHASE_ORDER: 'Bestellung erstellen',
        },
      },
      states: {
        empty: 'Es sind noch keine Belege vorhanden.',
        pagination: 'Seite {{page}} von {{totalPages}} · {{total}} Belege',
      },
      editor: {
        back: 'Zurück zur Übersicht',
        newTitle: 'Neuer Beleg',
        newSubtitle: 'Kunde wählen, Positionen erfassen und speichern.',
        type: 'Belegart',
        headSection: 'Belegkopf',
        itemsSection: 'Positionen',
        textsSection: 'Texte',
        customFieldsSection: 'Zusatzfelder',
        customFieldsInvalid: '{{count}} Feld prüfen',
        customFieldsInvalid_other: '{{count}} Felder prüfen',
        addCustomField: 'Zusatzfeld hinzufügen',
        addCustomFieldHint: 'Suchen Sie ein Belegfeld oder filtern Sie die Liste nach Kategorie.',
        removeCustomField: '{{field}} aus dem Beleg entfernen',
        searchCustomFields: 'Zusatzfelder suchen …',
        customFieldCategory: 'Zusatzfeld-Kategorie',
        allCustomFieldCategories: 'Alle Kategorien',
        uncategorizedFields: 'Ohne Kategorie',
        noDocumentCustomFields: 'Keine Zusatzfelder für diese Belegart eingerichtet.',
        noCustomFieldsSelected: 'Noch keine optionalen Zusatzfelder ausgewählt.',
        noCustomFieldsAvailable: 'Keine passenden weiteren Zusatzfelder gefunden.',
        itemCustomFieldColumns: 'Zusatzfeldspalten',
        customFieldsToast: 'Fehler bei Zusatzfeldern: {{field}} — {{reason}} [ID: {{id}}]',
        customFieldsMore: 'Ein weiteres Feld ist ebenfalls ungültig.',
        customFieldsMore_other: '{{count}} weitere Felder sind ebenfalls ungültig.',
        customerPlaceholder: 'Kunde suchen …',
        noCustomers: 'Keine Kunden gefunden.',
        incomplete: 'Bitte Kunde, Empfänger und mindestens eine Position ausfüllen.',
        created: 'Beleg angelegt.',
        saved: 'Beleg gespeichert.',
        partialQuantities: 'Teilmengen auswählen',
        conversionQuantitiesHint:
          'Ohne Teilmengenauswahl werden alle noch offenen Mengen übernommen. Bei Teilmengen überspringt 0 oder ein leeres Feld die Position. Bereits übernommene Mengen werden beim Erstellen geprüft.',
        conversionQuantityInvalid: 'Geben Sie mindestens eine gültige positive Menge ein.',
        converted: 'Folgebeleg erstellt.',
        convertFailed: 'Umwandlung in {{type}} fehlgeschlagen',
        locked: 'Beleg festgeschrieben.',
        customerLockedTitle: '🚨 Kunde ist für den Verkauf gesperrt',
        customerLockedReason: 'Grund: {{reason}}',
        customerLockedHint:
          'Für diesen Kunden darf kein Beleg erstellt werden. Bitte wenden Sie sich an die Buchhaltung.',
        customerLockedOverride:
          'Eine Freigabe ist nur mit der Zahlungsart Vorkasse oder Barzahlung möglich.',
        customerLockedSwitchToPrepayment: 'Auf Vorkasse umstellen',
      },
      deliveryTerms: {
        replaceManualConfirmation:
          'Manuell gesetzte Lieferkondition durch den Standard der neuen Adresse ersetzen?',
        reset: 'Auf Standard zurücksetzen',
        sources: {
          CUSTOMER_DEFAULT: 'Quelle: Kundenstandard',
          SHIPPING_ADDRESS: 'Quelle: Lieferadresse',
          MANUAL: 'Quelle: manuell überschrieben',
          NONE: 'Keine Lieferkondition hinterlegt',
        },
      },
      quoteValidity: {
        automaticHint:
          'Automatisch: {{days}} Tage ab Belegdatum. Sie können das Datum ändern oder leeren.',
        manualHint: 'Gültigkeitsdatum des Angebots. Bei Bedarf ändern oder leer lassen.',
        loading: 'Standardgültigkeit wird geladen …',
        loadError:
          'Die Standardgültigkeit konnte nicht geladen werden. Erneut versuchen oder das Datum manuell festlegen.',
      },
      fields: {
        customer: 'Kunde',
        recipient: 'Empfänger',
        documentDate: 'Belegdatum',
        validUntil: 'Gültig bis',
        reference: 'Ihre Referenz',
        language: 'Belegsprache',
        currency: 'Währung',
        taxStrategy: 'Steuerfindung',
        paymentMethod: 'Zahlungsart',
        paymentTermsDays: 'Zahlungsziel (Tage)',
        cashDiscountPct: 'Skonto %',
        cashDiscountDays: 'Skontotage',
        discountPct: 'Gesamtrabatt %',
        shippingAmount: 'Versandkosten',
        shippingAddress: 'Lieferadresse',
        noShippingAddress: 'Keine Lieferadresse',
        searchShippingAddress: 'Bezeichnung, Empfänger oder Ort suchen',
        noMatchingShippingAddress: 'Keine passende Lieferadresse gefunden.',
        unnamedShippingAddress: 'Lieferadresse ohne Angaben',
        deliveryTerms: 'Lieferkondition',
        headerText: 'Kopftext',
        footerText: 'Fußtext',
        internalNote: 'Interne Notiz',
      },
      items: {
        position: 'Pos.',
        article: 'Artikel',
        articlePlaceholder: 'Artikel suchen …',
        noArticles: 'Keine Artikel gefunden.',
        text: 'Freitext',
        quantity: 'Menge',
        unit: 'Einheit',
        unitPrice: 'Einzelpreis',
        discount: 'Rabatt %',
        taxRate: 'USt %',
        lineNet: 'Netto',
        remove: 'Position entfernen',
        addArticle: 'Artikelposition',
        addText: 'Textposition',
        batch: 'Charge',
        stock: 'Bestand',
        selectBatch: 'Charge wählen',
      },
      totals: {
        title: 'Berechnung',
        itemsNet: 'Positionen netto',
        discount: 'Gesamtrabatt {{pct}}',
        shipping: 'Versandkosten',
        net: 'Nettobetrag',
        tax: 'USt. {{pct}} auf {{base}}',
        gross: 'Gesamtbetrag',
        cashDiscount:
          'Bei Zahlung innerhalb von {{days}} Tagen: {{pct}} Skonto ({{amount}}) – zahlbar {{payable}}.',
      },
      batchPicker: {
        title: 'Chargenauswahl',
        description: 'Vorschlag für „{{product}}“ nach gewählter Entnahmestrategie.',
        strategy: 'Strategie',
        bestBefore: 'MHD',
        apply: 'Übernehmen',
        empty: 'Keine verfügbare Charge gefunden.',
        shortfall: 'Unterdeckung von {{quantity}} Einheiten.',
        levels: {
          EXPIRED: 'Abgelaufen',
          CRITICAL: 'Kritisch',
          WARNING: 'Warnung',
          OK: 'Unkritisch',
          UNKNOWN: 'Ohne MHD',
        },
      },
      preview: {
        title: 'PDF-Vorschau',
        refresh: 'Vorschau aktualisieren',
        download: 'PDF herunterladen',
        toggle: 'Vorschau ein-/ausblenden',
        stale: 'Die Vorschau zeigt den zuletzt gespeicherten Stand.',
      },
      email: {
        title: 'Beleg versenden',
        description: 'Beleg {{number}} als PDF-Anhang versenden.',
        to: 'Empfänger',
        subject: 'Betreff',
        body: 'Nachricht',
        submit: 'Verbindlich versenden',
        success: 'Beleg versendet.',
        failed: 'Der Versand ist fehlgeschlagen.',
      },
      delete: {
        title: 'Beleg löschen',
        description:
          'Der Entwurf {{number}} wird gelöscht. Diese Aktion lässt sich nicht rückgängig machen.',
        success: 'Beleg gelöscht.',
      },
    },
    users: {
      title: 'Benutzerverwaltung',
      subtitle: 'Zug\u00e4nge, Rollen und Kontostatus des Mandanten.',
      create: 'Benutzer anlegen',
      searchPlaceholder: 'Name oder E-Mail suchen',
      error: 'Die Benutzer konnten nicht geladen werden.',
      columns: {
        name: 'Name',
        email: 'E-Mail',
        role: 'Rolle',
        status: 'Status',
        twoFactor: '2FA',
        lastLogin: 'Letzte Anmeldung',
      },
      status: {
        active: 'Aktiv',
        inactive: 'Deaktiviert',
        locked: 'Gesperrt',
      },
      twoFactor: {
        on: 'Aktiv',
        off: 'Inaktiv',
      },
      filters: {
        role: 'Rolle filtern',
        allRoles: 'Alle Rollen',
      },
      empty: {
        title: 'Keine Benutzer gefunden',
        description: 'Passen Sie die Suche an oder legen Sie einen neuen Zugang an.',
      },
      actions: {
        label: 'Aktionen',
        edit: 'Bearbeiten',
        unlock: 'Entsperren',
        resetPassword: 'Passwort zur\u00fccksetzen',
        resetTwoFactor: '2FA zur\u00fccksetzen',
      },
      fields: {
        email: 'E-Mail',
        firstName: 'Vorname',
        lastName: 'Nachname',
        phone: 'Telefon',
        locale: 'Sprache',
        role: 'Rolle',
        isActive: 'Zugang aktiv',
        selfRoleHint: 'Die eigene Rolle kann nicht ge\u00e4ndert werden.',
      },
      sheet: {
        createTitle: 'Benutzer anlegen',
        createDescription: 'Der Zugang erh\u00e4lt ein einmaliges Initialpasswort.',
        editTitle: 'Benutzer bearbeiten',
        editDescription: 'Stammdaten, Rolle und Kontostatus anpassen.',
        passwordHint:
          'Das Initialpasswort wird nach dem Speichern einmalig angezeigt und muss beim ersten Anmelden ge\u00e4ndert werden.',
      },
      credentials: {
        title: 'Initialpasswort',
        description:
          'Bitte einmalig an {{email}} \u00fcbergeben \u2013 es wird nicht erneut angezeigt.',
        hint: 'Der Zugang muss das Passwort bei der ersten Anmeldung \u00e4ndern.',
      },
      toast: {
        created: 'Benutzer angelegt.',
        updated: 'Benutzer gespeichert.',
        unlocked: 'Konto entsperrt.',
        twoFactorReset: 'Zwei-Faktor-Authentifizierung zur\u00fcckgesetzt.',
      },
    },
    roles: {
      title: 'Rollen & Rechte',
      subtitle:
        'Berechtigungsmatrix je Rolle; \u00c4nderungen wirken bei der n\u00e4chsten Anmeldung.',
      list: 'Rollen',
      create: 'Rolle anlegen',
      error: 'Die Rollen konnten nicht geladen werden.',
      ownerHint: 'Die Eigent\u00fcmerrolle besitzt stets alle Rechte und ist nicht \u00e4nderbar.',
      permissionCount: '{{count}} Berechtigungen ausgew\u00e4hlt',
      fields: {
        name: 'Bezeichnung',
        description: 'Beschreibung',
      },
      matrix: {
        resource: 'Bereich',
        toggleRow: 'Alle Rechte f\u00fcr {{resource}}',
      },
      resources: {
        FEATURES: 'Funktionen & Module',
        CUSTOMERS: 'Kunden',
        PARTNER_RISK: 'Kundenrisiko & Sperren',
        PRODUCTS: 'Artikel',
        BATCHES: 'Chargen & Lager',
        DOCUMENTS: 'Belege',
        DOCUMENT_CUSTOMER_HEADERS: 'Kundendaten im Belegkopf',
        DMS: 'Dokumentenmanagement',
        ACCOUNTING: 'Buchhaltung',
        ANALYTICS: 'Auswertungen',
        EMPLOYEE_PERFORMANCE: 'Mitarbeiterperformance',
        SETTINGS: 'Einstellungen',
        USERS: 'Benutzer',
        TELEPHONY: 'Telefonie & KI',
        ANALYSIS: 'Analyse- und Nährwertprofile',
        MANUFACTURING: 'Produktion',
        TRACEABILITY: 'Chargenrückverfolgung',
        MRP: 'Materialbedarfsplanung',
        LABEL_MANAGEMENT: 'Etikettenmanagement',
        CUSTOM_FIELDS: 'Dynamische Zusatzfelder',
        INTRODUCTION: 'Einführungsmodus',
        SETUP: 'Mandanteneinrichtung',
        BACKUPS: 'Backups & Wiederherstellung',
      },
      actions: {
        CREATE: 'Anlegen',
        READ: 'Lesen',
        UPDATE: '\u00c4ndern',
        DELETE: 'L\u00f6schen',
        EXPORT: 'Export',
        APPROVE: 'Freigeben',
        RELEASE: 'Produktionsauftrag freigeben',
        RESERVE: 'Material reservieren',
        CONSUME: 'Material buchen',
        COMPLETE: 'Produktion fertigmelden',
        SIMULATE: 'Recall simulieren',
        BLOCK: 'Chargen sperren',
        REVIEW: 'Prüfen',
        MANAGE: 'Verwalten',
        ARCHIVE: 'Archivieren',
        ADMIN: 'Verwalten',
        USE: 'Telefonieren',
        VIEW: 'Einsehen',
        SET_LOCK: 'Sperre setzen',
        OVERRIDE_LOCK: 'Sperre aufheben',
        VIEW_OWN_LOGS: 'Eigene Gespr\u00e4che',
        VIEW_ALL_LOGS: 'Alle Gespr\u00e4che',
        VIEW_AI_SUMMARY: 'KI-Auswertung sehen',
        EDIT_AI_SUMMARY: 'KI-Auswertung \u00e4ndern',
        MANAGE_SETTINGS: 'Einstellungen verwalten',
        VIEW_COSTS: 'Kosten einsehen',
        RUN: 'Planung ausführen',
        CONFIGURE: 'Konfigurieren',
        CONVERT_PURCHASE: 'Bestellentwurf erzeugen',
        CONVERT_PRODUCTION: 'Produktionsentwurf erzeugen',
        IMPORT: 'Massenimport durchführen',
        ROLLBACK: 'Version zurücksetzen',
        MANAGE_FIELDS: 'Felder verwalten',
        MANAGE_GROUPS: 'Kategorien verwalten',
        READ_CONFIDENTIAL: 'Vertrauliche Felder lesen',
        WRITE_CONFIDENTIAL: 'Vertrauliche Felder ändern',
        VIEW_AUDIT: 'Änderungshistorie einsehen',
        CREATE_SETTINGS: 'Einstellungsbackup erstellen',
        CREATE_MASTER_DATA: 'Stammdatenbackup erstellen',
        CREATE_FULL: 'Vollbackup erstellen',
        DOWNLOAD: 'Backup herunterladen',
        RESTORE: 'Backup wiederherstellen',
        RESTORE_DRY_RUN: 'Restore-Trockenlauf',
        VIEW_DEPLOYMENT: 'Deployment-Backups ansehen',
        DELETE_DETAILS: 'Kundendetails löschen',
        EDIT_PRICES: 'Preise und Rabatte ändern',
        CANCEL: 'Belege stornieren',
      },
      delete: {
        title: 'Rolle l\u00f6schen',
        description: 'Die Rolle \u201e{{name}}\u201c wird dauerhaft entfernt.',
      },
      toast: {
        created: 'Rolle angelegt.',
        updated: 'Rolle gespeichert.',
        deleted: 'Rolle gel\u00f6scht.',
      },
    },
    profile: {
      title: 'Mein Profil',
      subtitle: 'Pers\u00f6nliche Angaben und Spracheinstellung.',
      account: 'Konto',
      emailChangeHint:
        'Eine neue E-Mail-Adresse erfordert Ihr aktuelles Passwort und deaktiviert E-Mail-2FA bis zur erneuten Bestätigung.',
      role: 'Rolle',
      tenant: 'Mandant',
      saved: 'Profil gespeichert.',
    },
    security: {
      title: 'Sicherheit',
      subtitle: 'Passwort, zweiter Faktor und aktive Sitzungen.',
      password: {
        title: 'Passwort \u00e4ndern',
        description:
          'Mindestens 12 Zeichen aus Gro\u00df- und Kleinbuchstaben, Ziffern und Sonderzeichen.',
        current: 'Aktuelles Passwort',
        new: 'Neues Passwort',
        confirm: 'Neues Passwort best\u00e4tigen',
        mismatch: 'Die Passw\u00f6rter stimmen nicht \u00fcberein.',
        submit: 'Passwort \u00e4ndern',
        changed: 'Passwort ge\u00e4ndert.',
        show: 'Passwort anzeigen',
        hide: 'Passwort verbergen',
        strengthLabel: 'Passwortst\u00e4rke',
        strength: {
          '0': 'Sehr schwach',
          '1': 'Schwach',
          '2': 'Mittel',
          '3': 'Stark',
          '4': 'Sehr stark',
        },
        rules: {
          length: 'Mindestens 12 Zeichen',
          uppercase: 'Ein Gro\u00dfbuchstabe',
          lowercase: 'Ein Kleinbuchstabe',
          digit: 'Eine Ziffer',
          special: 'Ein Sonderzeichen',
        },
      },
      forceChange: {
        title: 'Passwort\u00e4nderung erforderlich',
        description:
          'Ihr Zugang wurde mit einem Initialpasswort eingerichtet. Bitte vergeben Sie jetzt ein eigenes Passwort.',
      },
      twoFactor: {
        title: 'Zwei-Faktor-Authentifizierung',
        description: 'Zus\u00e4tzlicher Schutz \u00fcber eine Authenticator-App (TOTP).',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        enable: 'Aktivieren',
        disable: 'Deaktivieren',
        enableTitle: 'Zwei-Faktor-Authentifizierung einrichten',
        disableTitle: 'Zwei-Faktor-Authentifizierung deaktivieren',
        disableDescription:
          'Zur Best\u00e4tigung werden Passwort und ein aktueller Code ben\u00f6tigt.',
        intro:
          'Sie ben\u00f6tigen eine Authenticator-App wie 1Password, Aegis oder Google Authenticator.',
        start: 'Einrichtung starten',
        steps: {
          scan: 'Schritt 1 von 3: Einrichtung starten.',
          verify: 'Schritt 2 von 3: QR-Code scannen und Code eingeben.',
          codes: 'Schritt 3 von 3: Backup-Codes sichern.',
        },
        qrAlt: 'QR-Code zur Einrichtung der Authenticator-App',
        enterCode: 'Code aus der App eingeben',
        code: 'Best\u00e4tigungscode',
        backupHint:
          'Diese Codes ersetzen den zweiten Faktor bei Ger\u00e4teverlust. Jeder Code ist einmal g\u00fcltig.',
        downloadCodes: 'Backup-Codes herunterladen',
        enabled: 'Zwei-Faktor-Authentifizierung aktiviert.',
        disabled: 'Zwei-Faktor-Authentifizierung deaktiviert.',
        authenticator: 'Authenticator-App (TOTP)',
        makePrimary: 'Als bevorzugt festlegen',
      },
      emailTwoFactor: {
        title: 'E-Mail-Code aktivieren',
        disableTitle: 'E-Mail-Code deaktivieren',
        method: 'E-Mail-Code',
        description: 'Bestätigen Sie zuerst Ihr Passwort und anschließend den Code aus der E-Mail.',
        disableDescription:
          'Geben Sie Ihr Passwort und einen aktuellen Authenticator- oder Backup-Code ein.',
        secondFactor: 'Authenticator- oder Backup-Code',
        sentTo: 'Ein Sicherheitscode wurde an {{email}} gesendet.',
        send: 'Code senden',
        confirm: 'Aktivieren',
        enabled: 'E-Mail-2FA wurde aktiviert.',
        disabled: 'E-Mail-2FA wurde deaktiviert.',
        independenceWarning:
          'Eine Authenticator-App ist meist unabhängiger und sicherer als E-Mail, besonders wenn beide Konten auf demselben Gerät verwendet werden.',
      },
      twoFactorPolicy: {
        title: '2FA-Mandantenrichtlinie',
        description: 'Erlaubte Methoden und Pflichten für diesen Mandanten steuern.',
        error: 'Die Sicherheitsrichtlinie konnte nicht geladen werden.',
        methods: { TOTP: 'Authenticator-App erlauben', EMAIL: 'E-Mail-Code erlauben' },
        required: 'Zwei-Faktor-Authentifizierung für alle Benutzer verpflichtend',
        emailEnabled: 'E-Mail-2FA für diesen Mandanten aktivieren',
        privilegedTotp: 'TOTP für privilegierte Rollen verpflichtend',
        requiredRoles: 'Rollen mit 2FA-Pflicht',
        roles: { OWNER: 'Inhaber', ADMIN: 'Administrator' },
        validity: 'Gültigkeit des E-Mail-Codes (Minuten)',
        cooldown: 'Wartezeit vor erneutem Versand (Sekunden)',
      },
      sessions: {
        title: 'Aktive Sitzungen',
        description: 'Angemeldete Ger\u00e4te dieses Kontos.',
        empty: 'Keine aktiven Sitzungen.',
        error: 'Die Sitzungen konnten nicht geladen werden.',
        current: 'Diese Sitzung',
        unknownDevice: 'Unbekanntes Ger\u00e4t',
        revoke: 'Beenden',
        revokeOthers: 'Alle anderen Sitzungen beenden',
        revoked: 'Sitzung beendet.',
        revokedOthers: 'Alle anderen Sitzungen wurden beendet.',
      },
    },
    securityLog: {
      title: 'Sicherheitsprotokoll',
      subtitle: 'Anmeldungen, Rechte\u00e4nderungen und sicherheitsrelevante Ereignisse.',
      searchPlaceholder: 'E-Mail oder IP-Adresse suchen',
      filterEvent: 'Ereignis filtern',
      allEvents: 'Alle Ereignisse',
      empty: 'Keine Eintr\u00e4ge im gew\u00e4hlten Zeitraum.',
      error: 'Das Protokoll konnte nicht geladen werden.',
      columns: {
        timestamp: 'Zeitpunkt',
        event: 'Ereignis',
        user: 'Benutzer',
        ip: 'IP-Adresse',
      },
      events: {
        LOGIN_SUCCESS: 'Anmeldung erfolgreich',
        LOGIN_FAILED: 'Anmeldung fehlgeschlagen',
        LOGOUT: 'Abmeldung',
        TWO_FACTOR_ENABLED: '2FA aktiviert',
        TWO_FACTOR_DISABLED: '2FA deaktiviert',
        TWO_FACTOR_FAILED: '2FA fehlgeschlagen',
        TWO_FACTOR_METHOD_CHANGED: '2FA-Methode geändert',
        TWO_FACTOR_RESET: '2FA zurückgesetzt',
        EMAIL_CHANGED: 'E-Mail-Adresse geändert',
        PASSWORD_CHANGED: 'Passwort ge\u00e4ndert',
        PASSWORD_RESET: 'Passwort zur\u00fcckgesetzt',
        ACCOUNT_LOCKED: 'Konto gesperrt',
        ACCOUNT_UNLOCKED: 'Konto entsperrt',
        ROLE_UPDATED: 'Rolle ge\u00e4ndert',
        PERMISSIONS_MODIFIED: 'Berechtigungen ge\u00e4ndert',
        SESSION_REVOKED: 'Sitzung beendet',
        USER_CREATED: 'Benutzer angelegt',
        USER_UPDATED: 'Benutzer ge\u00e4ndert',
      },
    },
    notifications: {
      title: 'Benachrichtigungen',
      bell: 'Benachrichtigungen öffnen',
      bellWithCount: '{{count}} ungelesene Benachrichtigungen',
      unread: 'Ungelesen',
      open: 'Öffnen',
      markAllRead: 'Alle gelesen',
      manage: 'Benachrichtigungen verwalten',
      error: 'Die Benachrichtigungen konnten nicht geladen werden.',
      tabs: {
        all: 'Alle',
        unread: 'Ungelesen',
        critical: 'Kritisch',
      },
      empty: {
        title: 'Keine Benachrichtigungen',
        description: 'Neue Ereignisse erscheinen hier in Echtzeit.',
      },
      categories: {
        STOCK_LOW: 'Meldebestand',
        BATCH_EXPIRING: 'MHD-Warnung',
        ORDER_CREATED: 'Auftragseingang',
        INVOICE_OVERDUE: 'Überfällige Rechnung',
        TASK_ASSIGNED: 'Wiedervorlage',
        SYSTEM: 'System',
      },
    },
    notificationSettings: {
      title: 'Benachrichtigungen',
      subtitle: 'Legen Sie fest, welche Ereignisse Sie wo erreichen.',
      matrixTitle: 'Zustellwege',
      matrixDescription:
        'Die Glocke meldet Ereignisse sofort in der Anwendung, die E-Mail erreicht Sie auch außerhalb.',
      error: 'Die Einstellungen konnten nicht geladen werden.',
      autoSave: 'Änderungen werden sofort gespeichert.',
      saved: 'Einstellung gespeichert.',
      columns: {
        event: 'Ereignis',
        inApp: 'In-App Glocke',
        email: 'E-Mail Sofort-Benachrichtigung',
      },
      descriptions: {
        STOCK_LOW: 'Bestand eines Artikels erreicht den Meldebestand.',
        BATCH_EXPIRING: 'Charge läuft innerhalb der nächsten 30 Tage ab.',
        ORDER_CREATED: 'Ein neuer Auftrag ist eingegangen oder wurde bestätigt.',
        INVOICE_OVERDUE: 'Eine Rechnung ist über das Fälligkeitsdatum hinaus offen.',
        TASK_ASSIGNED: 'Eine Telefonnotiz mit Wiedervorlage wurde Ihnen zugewiesen.',
        SYSTEM: 'Sicherheits- und Systemereignisse des Mandanten.',
      },
    },
    company: {
      title: 'Firmendaten',
      subtitle: 'Stammdaten, Bankverbindung und Vorgaben für Belege.',
      error: 'Die Firmendaten konnten nicht geladen werden.',
      saved: 'Firmendaten gespeichert.',
      invalid: 'Bitte prüfen Sie die markierten Felder.',
      sections: {
        identity: 'Unternehmen',
        identityHint: 'Diese Angaben erscheinen im Belegkopf und in der Fußzeile.',
        tax: 'Steuer & Bank',
        taxHint: 'Pflichtangaben nach § 14 UStG sowie die Bankverbindung für Rechnungen.',
        layout: 'Beleg-Layout',
        layoutHint: 'Logo und Akzentfarbe erscheinen in jedem erzeugten PDF.',
        documents: 'Beleg-Vorgaben',
        documentsHint: 'Vorbelegung für neue Angebote und Rechnungen.',
      },
      fields: {
        companyName: 'Firmenname',
        legalForm: 'Rechtsform',
        ownerName: 'Inhaber/Geschäftsführung',
        street: 'Straße und Hausnummer',
        zip: 'PLZ',
        city: 'Ort',
        country: 'Land',
        phone: 'Telefon',
        email: 'E-Mail',
        website: 'Website',
        vatId: 'USt-IdNr.',
        taxNumber: 'Steuernummer',
        commercialRegister: 'Handelsregister',
        commercialRegisterHint: 'z. B. HRB 12345, Amtsgericht Stuttgart',
        bankName: 'Bank',
        iban: 'IBAN',
        bic: 'BIC',
        primaryColor: 'Primärfarbe',
        invoiceDueDays: 'Zahlungsziel in Tagen',
        quoteValidityDays: 'Angebotsgültigkeit in Tagen',
        defaultEmailSender: 'Absenderadresse für Belege',
        defaultEmailSenderHint: 'Wird als Antwortadresse im Belegversand verwendet.',
      },
      legalForms: {
        EINZELUNTERNEHMEN: 'Einzelunternehmen',
        FREIBERUFLER: 'Freiberufler',
        EK: 'e. K.',
        GBR: 'GbR',
        OHG: 'OHG',
        KG: 'KG',
        GMBH: 'GmbH',
        GMBH_CO_KG: 'GmbH & Co. KG',
        UG: 'UG (haftungsbeschränkt)',
        AG: 'AG',
        SE: 'SE',
        EG: 'eG',
        LTD: 'Ltd.',
        GESMBH: 'GesmbH (Österreich)',
        AG_CH: 'AG (Schweiz)',
        SONSTIGE: 'Sonstige',
      },
      logo: {
        empty: 'Kein Logo',
        preview: 'Logo-Vorschau',
        select: 'Logo auswählen',
        remove: 'Logo entfernen',
        hint: 'PNG, JPEG oder SVG bis {{size}} KB.',
        invalidType: 'Erlaubt sind PNG, JPEG und SVG.',
        tooLarge: 'Die Datei ist größer als {{size}} KB.',
      },
      color: {
        custom: 'Eigene Farbe wählen',
        previewTitle: 'Rechnung RE-2026-00001',
        previewHint: 'Belegkopf und Tabellenlinien',
      },
    },
    accounting: {
      periods: {
        lastMonth: 'Letzter Monat',
        currentMonth: 'Aktueller Monat',
        q1: 'Q1',
        q2: 'Q2',
        q3: 'Q3',
        q4: 'Q4',
        currentYear: 'Laufendes Jahr',
        custom: 'Freier Zeitraum',
        from: 'Von',
        to: 'Bis',
      },
      months: {
        '1': 'Januar',
        '2': 'Februar',
        '3': 'März',
        '4': 'April',
        '5': 'Mai',
        '6': 'Juni',
        '7': 'Juli',
        '8': 'August',
        '9': 'September',
        '10': 'Oktober',
        '11': 'November',
        '12': 'Dezember',
      },
      federalStates: {
        '01': 'Schleswig-Holstein',
        '02': 'Hamburg',
        '03': 'Niedersachsen',
        '04': 'Bremen',
        '05': 'Nordrhein-Westfalen',
        '06': 'Hessen',
        '07': 'Rheinland-Pfalz',
        '08': 'Baden-Württemberg',
        '09': 'Bayern',
        '10': 'Saarland',
        '11': 'Berlin',
        '12': 'Brandenburg',
        '13': 'Mecklenburg-Vorpommern',
        '14': 'Sachsen',
        '15': 'Sachsen-Anhalt',
        '16': 'Thüringen',
      },
      natureOfTransaction: {
        '11': 'Endgültiger Kauf/Verkauf',
        '12': 'Ansichts- oder Probesendung',
        '21': 'Rücksendung von Waren',
        '22': 'Ersatzlieferung für zurückgesandte Waren',
        '23': 'Ersatzlieferung für nicht zurückgesandte Waren',
        '31': 'Lieferung im Rahmen von Hilfsprogrammen',
        '41': 'Lohnveredelung, Rückkehr vorgesehen',
        '51': 'Rücksendung nach Lohnveredelung',
        '91': 'Miete, Leihe, Leasing über 24 Monate',
        '99': 'Sonstige Geschäfte',
      },
      modeOfTransport: {
        '1': 'Seeverkehr',
        '2': 'Eisenbahnverkehr',
        '3': 'Straßenverkehr',
        '4': 'Luftverkehr',
        '5': 'Postsendungen',
        '7': 'Feste Transporteinrichtungen',
        '8': 'Binnenwasserstraßen',
        '9': 'Eigener Antrieb',
      },
      datev: {
        title: 'DATEV-Export',
        subtitle: 'Buchungsstapel im Format EXTF für die Übergabe an die Kanzlei.',
        openSettings: 'Konfiguration',
        periodSection: 'Zeitraum und Belegauswahl',
        reconciliation: 'Abstimmsumme: Soll {{debit}} · Haben {{credit}}',
        tabs: {
          export: 'Export',
          history: 'Export-Historie',
        },
        filters: {
          includeCancellations: 'Stornorechnungen und Gutschriften einbeziehen',
          includeAlreadyExported: 'Bereits exportierte Belege erneut ausgeben (Wiederholungslauf)',
        },
        kpi: {
          records: 'Buchungssätze',
          documents: 'Belege',
          net: 'Nettovolumen',
          gross: 'Bruttovolumen',
        },
        columns: {
          date: 'Belegdatum',
          number: 'Belegnummer',
          customer: 'Kunde',
          account: 'Konto',
          contraAccount: 'Gegenkonto',
          buKey: 'BU',
          net: 'Netto',
          tax: 'USt.',
          gross: 'Brutto',
          debitCredit: 'S/H',
          state: 'Status',
        },
        state: {
          locked: 'Festgeschrieben',
          open: 'Offen',
        },
        states: {
          empty: 'Im gewählten Zeitraum gibt es keine exportierbaren Belege.',
        },
        validation: {
          clean: 'Alle Belege des Zeitraums sind exportbereit.',
          invalidRange: 'Das Startdatum darf nicht nach dem Enddatum liegen.',
          openCustomer: 'Kunde öffnen',
          openDocument: 'Beleg {{number}} öffnen',
        },
        issues: {
          DEBTOR_ACCOUNT_MISSING_one: '{{count}} Beleg ohne Debitorenkonto beim Kunden.',
          DEBTOR_ACCOUNT_MISSING_other: '{{count}} Belege ohne Debitorenkonto beim Kunden.',
          REVENUE_ACCOUNT_MISSING_one: '{{count}} Beleg ohne zugeordnetes Erlöskonto.',
          REVENUE_ACCOUNT_MISSING_other: '{{count}} Belege ohne zugeordnetes Erlöskonto.',
          VAT_ID_MISSING_one: '{{count}} steuerfreie EU-Lieferung ohne USt-IdNr. des Kunden.',
          VAT_ID_MISSING_other: '{{count}} steuerfreie EU-Lieferungen ohne USt-IdNr. des Kunden.',
          DOCUMENT_NOT_LOCKED_one:
            '{{count}} Beleg ist noch nicht festgeschrieben und wird beim Export festgeschrieben.',
          DOCUMENT_NOT_LOCKED_other:
            '{{count}} Belege sind noch nicht festgeschrieben und werden beim Export festgeschrieben.',
          DOCUMENT_ALREADY_EXPORTED_one: '{{count}} Beleg wurde bereits übergeben.',
          DOCUMENT_ALREADY_EXPORTED_other: '{{count}} Belege wurden bereits übergeben.',
          SETTINGS_INCOMPLETE_one: 'Berater- und Mandantennummer fehlen in der Konfiguration.',
          SETTINGS_INCOMPLETE_other: 'Berater- und Mandantennummer fehlen in der Konfiguration.',
          AMOUNT_ZERO_one: '{{count}} Beleg ohne betragswirksame Position.',
          AMOUNT_ZERO_other: '{{count}} Belege ohne betragswirksame Position.',
        },
        export: {
          action: 'Buchungsstapel exportieren (.csv)',
          success: 'Buchungsstapel erzeugt und heruntergeladen.',
        },
        history: {
          exportedAt: 'Exportiert am',
          period: 'Zeitraum',
          filename: 'Datei',
          records: 'Sätze / Belege',
          volume: 'Bruttovolumen',
          checksum: 'Prüfsumme',
          download: 'Erneut herunterladen',
          repeat: 'Wiederholung',
          empty: 'Es wurden noch keine Buchungsstapel exportiert.',
          hint: 'Die Prüfsumme belegt, dass die erneut erzeugte Datei dem archivierten Lauf entspricht.',
        },
      },
      settings: {
        title: 'Buchhaltungs-Konfiguration',
        subtitle: 'Kontenrahmen, DATEV-Stammdaten und Intrastat-Vorgaben des Mandanten.',
        chartSection: 'Kontenrahmen und DATEV-Stammdaten',
        mappingSection: 'Erlöskonten je Steuerfall',
        intrastatSection: 'Intrastat-Vorgaben',
        saved: 'Einstellungen gespeichert.',
        charts: {
          SKR03: 'Prozessgliederung; Erlöse im Bereich 8000–8999.',
          SKR04: 'Abschlussgliederung; Erlöse im Bereich 4000–4999.',
        },
        fields: {
          consultantNumber: 'Beraternummer',
          clientNumber: 'Mandantennummer',
          fiscalYearStart: 'Wirtschaftsjahresbeginn',
          accountNumberLength: 'Sachkontenlänge',
          debtorAccountRangeStart: 'Debitoren-Startnummer',
          dictationKey: 'Diktatkürzel',
          reportingVatId: 'USt-IdNr. des Meldepflichtigen',
          federalState: 'Bundesland',
          natureOfTransaction: 'Standard-Geschäftsart',
          modeOfTransport: 'Standard-Verkehrszweig',
        },
        mapping: {
          case: 'Steuerfall',
          account: 'Erlöskonto',
          buKey: 'BU-Schlüssel',
          accountFor: 'Erlöskonto für {{case}}',
          buKeyFor: 'BU-Schlüssel für {{case}}',
          automatic: 'Automatik',
        },
        revenueCases: {
          DOMESTIC_STANDARD: { label: 'Inland 19 %', hint: 'Regelsteuersatz im Inland.' },
          DOMESTIC_REDUCED: { label: 'Inland 7 %', hint: 'Ermäßigter Steuersatz im Inland.' },
          DOMESTIC_EXEMPT: { label: 'Inland steuerfrei', hint: 'Steuerfreie Umsätze im Inland.' },
          INTRA_COMMUNITY: {
            label: 'EU steuerfrei',
            hint: 'Innergemeinschaftliche Lieferung, § 4 Nr. 1b UStG.',
          },
          EXPORT_NON_EU: { label: 'Drittland', hint: 'Ausfuhrlieferung, § 4 Nr. 1a UStG.' },
          REVERSE_CHARGE: {
            label: 'Reverse Charge',
            hint: 'Steuerschuldnerschaft des Leistungsempfängers, § 13b UStG.',
          },
        },
        debtors: {
          action: 'Debitorenkonten vergeben',
          assigned_one: '{{count}} Debitorenkonto vergeben.',
          assigned_other: '{{count}} Debitorenkonten vergeben.',
        },
      },
      intrastat: {
        title: 'Intrastat-Meldung',
        subtitle: 'Versendungen in andere EU-Mitgliedstaaten je Bezugsmonat.',
        periodSection: 'Meldezeitraum',
        fields: {
          year: 'Meldejahr',
          month: 'Bezugsmonat',
          direction: 'Richtung',
        },
        directions: {
          DISPATCH: 'Versendung',
          ARRIVAL: 'Eingang',
        },
        kpi: {
          value: 'Rechnungsbetrag',
          weight: 'Eigenmasse',
          positions: 'Meldepositionen',
        },
        columns: {
          commodityCode: 'Warennummer (KN8)',
          destination: 'Bestimmungsland',
          origin: 'Ursprungsland',
          nature: 'Geschäftsart',
          transport: 'Verkehrszweig',
          weight: 'Eigenmasse',
          invoiced: 'Rechnungsbetrag',
          statistical: 'Statistischer Wert',
          partnerVatId: 'USt-IdNr. Partner',
        },
        issueFields: {
          commodityCode: 'Warennummer fehlt oder ist nicht 8-stellig',
          countryOfOrigin: 'Ursprungsland fehlt',
          netWeight: 'Nettogewicht fehlt',
          destinationCountry: 'Bestimmungsland fehlt',
        },
        readiness: {
          clean: 'Alle meldepflichtigen Positionen sind vollständig.',
          blocked_one: '{{count}} Artikel blockiert die Meldung.',
          blocked_other: '{{count}} Artikel blockieren die Meldung.',
          openProduct: 'Artikel öffnen',
        },
        states: {
          empty: 'Für diesen Bezugsmonat gibt es keine meldepflichtigen Versendungen.',
        },
        export: {
          csv: 'Kontrollliste (.csv)',
          xml: 'INSTAT/XML für IDEV',
          success: 'Meldedatei erzeugt und heruntergeladen.',
        },
      },
    },
  },
} as const;
